import React, { useState, useEffect, useMemo, forwardRef } from "react";
import { TableVirtuoso } from "react-virtuoso";
import { handleApiError } from "../../Helpers/handleApiError ";
import UserSection from "../../Services/User/UserLogin";
import Swal from "sweetalert2";
import UserTopbar from "../UserTopbar";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Modal, TextField, Tabs, Tab } from "@mui/material";
import { AddCircleOutline, Delete, Info } from "@mui/icons-material";
import Autocomplete from "./Autocomplete";
import * as XLSX from "xlsx";
import {
  Box,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import Select, { components } from "react-select";
import RotateLeftRoundedIcon from "@mui/icons-material/RotateLeftRounded";
import Loader from "../utils/Loader";
import { useLocation } from "react-router-dom";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import DriveFolderUploadSharpIcon from "@mui/icons-material/DriveFolderUploadSharp";
import { useOutletContext } from "react-router-dom";
import BallotIcon from "@mui/icons-material/Ballot";
import NotificationDrawer from "../NotificationDrawer";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { ToastContainer, toast } from "react-toastify";
import SmartSearchButton from "../utils/SmartSearchButton";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import { useDispatch, useSelector } from "react-redux";
import { fetchDraft } from "../../redux/slices/draftSlice";
import PostAddIcon from "@mui/icons-material/PostAdd";
import SaveIcon from "@mui/icons-material/Save";
import FilterListIcon from "@mui/icons-material/FilterList";
import { fetchUserClientOption } from "../../redux/slices/clientSlice";
import DefaultValueManagerModal from "../utils/DefaultValueManagerModal";
import SmartFilterProductManager from "../utils/SmartFilterProductManager";
import InventoryPopUp from "../utils/InventoryPopUp";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import SyncIcon from "@mui/icons-material/Sync";
import StockLable from "../utils/StockLable";
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import SelectionLoadingStatus from "../utils/SelectionLoadingStatus";

const formatStockValue = (num) => {
  if (num === 0) return "0";
  if (!num || isNaN(num)) return "-";
  const val = Math.abs(num);
  if (val >= 10000000) return (num / 10000000).toFixed(1) + " Cr";
  if (val >= 100000) return (num / 100000).toFixed(1) + " L";
  if (val >= 1000) return (num / 1000).toFixed(1) + " K";
  return num.toString();
};

const VirtuosoTableComponents = {
  Table: (props) => <table {...props} className="text-sm productTable min-w-max text-center" />,
  TableHead: forwardRef((props, ref) => <thead {...props} ref={ref} className="sticky top-0 z-20 bg-gray-900 text-white" />),
  TableBody: forwardRef((props, ref) => <tbody {...props} ref={ref} className="bg-white/95" />),
  TableFoot: forwardRef((props, ref) => <tfoot {...props} ref={ref} className="bg-white/80 sticky bottom-0 z-10 shadow-lg" />),
  TableRow: (props) => {
      return <tr {...props} className="transition-colors duration-200 hover:bg-gray-50 border-b border-gray-200" id={"sku-" + (props.item?.id || "")} />
  }
};

const UserProjects = () => {
  const dispatch = useDispatch();
  const [defaultValuePopUp, setDefaultValuePopUp] = useState(false);
  const [defaultValue, setDefaultValue] = useState({
    qty: 1,
    discount_per: 0,
  });
  const [smartFilterProduct, setSmartFilterProduct] = useState([]);
  const [selectedDate, setSelectedDate] = useState();
  const [isDisabled, setIsDisabled] = useState(false);
  const [expandMore, setExpandMore] = useState(false);
  const fileInputRef = useRef(null);
  const { isSidebarOpen } = useOutletContext();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const clientsId = params.get("client_id");
  const { cid, clientName, projectId } = useParams();
  const [client, setClient] = useState();
  const navigate = useNavigate();
  const [removedIds, setRemovedIds] = useState([]);
  const [selectionId, setSelectionID] = useState("1");
  const [selectionClient, setselectionClient] = useState();
  const [secName, setSecName] = useState("");
  const [loading, setLoading] = useState(false);
  const [rows_id, setRowsId] = useState(1);
  const [files, setFiles] = useState(null);
  const [upload, setupload] = useState(false);
  const [error, setError] = useState("");
  const [excelData, setExcelData] = useState([]);
  const [selectionHistory, setSelectionHistory] = useState({});
  // const [activeRowId, setActiveRowId] = useState(null);
  const [tableData, setTableData] = useState([
    {
      id: rows_id,
      check: false,
      sku_code: "",
      brand: "",
      brand_description: "",
      finish: "",
      image: "",
      quantity: "",
      area: "",
      mrp: "",
      collection: "",
      discount_price: null,
      discount_per: null,
      gst: "",
      total: "",
      discount: "",
      selection: selectionId,
      active: true,
      selection_name: null,
      client_id: null,
      type: "add",
      check_gst: "",
      unit: 0,
      copy_id: 0,
      hsnCode: "",
      category: "",
      priceSegment: "",
      spare_fg: "",
      project_details_id: "",
    },
  ]);
  const { clientsOption } = useSelector((state) => state.client);
  const selectionDetails = location.state?.selectionDetails || [];

  const sortTableDataAsc = (property) => {
    const sortedData = [...tableData].sort((a, b) => {
      const valueA = Number(a[property]) || 0;
      const valueB = Number(b[property]) || 0;

      return valueA - valueB;
    });
    setTableData(sortedData);
  };

  const sortTableDataDesc = (property) => {
    const sortedData = [...tableData].sort((a, b) => {
      const valueA = Number(a[property]) || 0;
      const valueB = Number(b[property]) || 0;

      return valueB - valueA;
    });
    setTableData(sortedData);
  };

  const sortTableAlphabetDataAsc = (property) => {
    const sortedData = [...tableData].sort((a, b) =>
      (a[property] || "").localeCompare(b[property] || "")
    );
    setTableData(sortedData);
  };

  const sortTableAlphabetDataDesc = (property) => {
    const sortedData = [...tableData].sort((a, b) =>
      (b[property] || "").localeCompare(a[property] || "")
    );
    setTableData(sortedData);
  };

  const handleDebounce = () => {
    setIsDisabled(true);
    setTimeout(() => {
      setIsDisabled(false);
    }, 2000);
  };

  const [selection, setSelection] = useState();
  const [errorMessages, setErrorMessages] = useState([]);
  const [amountType, setAmountType] = useState("price");
  const [sub_Total, setSub_Total] = useState(0);
  const [gst, setGst] = useState(true);
  const [searchqty, setsearchqty] = useState(defaultValue?.qty);
  const [percFilter, setPercFilter] = useState(defaultValue?.discount_per);
  const [draftDatas, setdraftData] = useState([]);

  const [draftId, setDraftId] = useState(null);
  const { draftData, getStatus } = useSelector((state) => state.draft);

  useEffect(() => {
    const draftIdFromStorage = localStorage.getItem("draft_id");
    if (draftIdFromStorage) {
      setDraftId(draftIdFromStorage);

      const timer = setTimeout(() => {
        localStorage.removeItem("draft_id");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    dispatch(fetchUserClientOption())
  }, [])

  useEffect(() => {
    if (draftId) {
      dispatch(fetchDraft(draftId));
    }
  }, [draftId]);

  useEffect(() => {
    if (draftId && getStatus === "succeeded") {
      setdraftData(draftData);
    } else {
      setdraftData([]);
    }
  }, [draftData]);

  // useEffect(() => {
  //   if (draftDatas && draftDatas.data && draftDatas.data.section) {
  //     const allSections = Object.values(draftDatas.data.section);

  //     const firstSectionKey = Object.keys(draftDatas.data.section)[0];
  //     const firstItem = draftDatas.data.section[firstSectionKey]?.[0];
  //     const totalGst = (firstItem?.gst == null || firstItem?.gst == 0) ? 0 : 1;
  //     setGst(totalGst);

  //     const flattenedData = allSections.flatMap((section) =>
  //       section.map((item) => ({
  //         edit_id: item.id,
  //         id: item.id,
  //         check: false,
  //         sku_code: item.sku_code,
  //         brand: item.product_attr.brand,
  //         product_desc: item.product_attr.product_desc,
  //         finish: item.product_attr.finish,
  //         image: item.product_attr.image,
  //         quantity: item.qty,
  //         area: item.area,
  //         mrp: item.product_attr.mrp,
  //         collection: item.product_attr.collection,
  //         Group: item.product_attr.product_typ_group,
  //         discount_price: item.disc_price,
  //         discount_per: item.disc_per,
  //         gst: item.gst,
  //         total: item.total,
  //         discount: "",
  //         selection: item.section_id,
  //         active: true,
  //         selection_name: item.section_name,
  //         client_id: null,
  //         type: "add",
  //         check_gst: "",
  //         unit: item.unit,
  //         copy_id: item.copy_id,
  //         hsnCode: item.product_attr.hsnCode,
  //         category: item.product_attr.category,
  //         priceSegment: item.product_attr.priceSegment,
  //         spare_fg: item.product_attr.spare_fg,
  //         stock: item.product_attr?.stock?.stockAvailable || 0,
  //         stockIndicator: item.product_attr?.stock?.stockIndicator || "N/A"
  //       }))
  //     );

  //     setselectionClient(draftDatas.data.client_id);
  //     let secname = draftDatas?.data?.section?.[1]?.[0]?.section_name ?? "";
  //     setSecName(secname);
  //     setTableData(flattenedData);
  //   }
  // }, [draftData, draftDatas]);

  useEffect(() => {
    Selection();
    setselectionClient(clientsId);
    const clientIdFromStorage = localStorage.getItem("client_id");
    if (clientIdFromStorage) {
      setselectionClient(clientIdFromStorage);
      const timer = setTimeout(() => {
        localStorage.removeItem("client_id");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, []);

  const getLargestId = (indexId) => {
    const maxId = Math.max(...tableData.map((item) => item.id), 0);
    const indexsum = indexId ? indexId : 0;
    return maxId + indexsum + 1; // Return next largest ID
  };

  const handleSelected = async (selectedArray) => {
    const currentSelectionDataCount = tableData.filter(
      (row) => row.selection === selectionId
    ).length;

    if ((currentSelectionDataCount + selectedArray?.length) > 300) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Rows Limit reached = 300",
      });
      return false;
    }

    if (!secName) {
      toast.warning("Add Selection Name Before Proceeding");
      return;
    } else if (!selectionClient) {
      toast.warning("Select Client Before Proceeding");
      return;
    }

    const qty = defaultValue?.qty ? Number(defaultValue.qty) : 1;

    let total_slot = 0;
    const newSelectionId = selectionId;

    // Calculate the total number of selected items for the given selection
    for (let i = 0; i < tableData.length; i++) {
      if (tableData[i].selection === newSelectionId) {
        total_slot += 1;
      }
    }

    // Check if the total slot exceeds the limit
    if (total_slot >= 300) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Rows Limit reached = 300",
      });
      return false;
    }

    // Filter out items with empty SKU codes
    const filteredItems = tableData.filter((item) => item.sku_code !== "");

    let IdIndex = 1;
    selectedArray.forEach((selected) => {
      let hasgst;
      let unit_price = parseFloat(selected.mrp * 100) / (100 + selected.gst);
      let unit_mrp = unit_price;
      let ref_total = selected.mrp;

      if (gst == 1) {
        hasgst = selected.gst;
        ref_total = parseFloat(selected.mrp);
      } else {
        hasgst = 0;
        ref_total = parseFloat(unit_mrp);
      }
      const discountPer = defaultValue?.discount_per
        ? Number(defaultValue.discount_per)
        : 0;
      const qty = defaultValue?.qty ? Number(defaultValue.qty) : 1;
      // base price used for discount calculation: MRP if gst inclusive else unit price
      const basePriceForDiscount = gst == 1 ? selected.mrp : unit_mrp;
      const discountPricePerUnit = parseFloat(
        ((basePriceForDiscount * discountPer) / 100).toFixed(1)
      );
      const totalAmount = parseFloat(
        (basePriceForDiscount * qty - discountPricePerUnit * qty).toFixed(1)
      );

      const resdata = {
        id: getLargestId(IdIndex),
        check: false,
        sku_code: selected.sku_code,
        collection: selected.collection,
        brand: selected.brand,
        product_desc: selected.product_desc,
        finish: selected.finish,
        image: selected.image,
        quantity: qty,
        area: "",
        mrp: selected.mrp,
        discount_price: discountPricePerUnit,
        discount_per: discountPer,
        gst: hasgst,
        total: totalAmount,
        Spare: selected.spare_fg,
        Group: selected.product_typ_group,
        discount: 0,
        selection: selectionId,
        active: true,
        selection_name: secName,
        check_gst: selected.gst,
        unit: unit_mrp,
        copy_id: 0,
        hsnCode: selected.hsnCode,
        category: selected.category,
        priceSegment: selected.priceSegment,
        spare_fg: selected.spare_fg,
        stock: selected?.stock?.stockAvailable || 0,
        stockIndicator: selected?.stock?.stockIndicator || "N/A"
      };
      IdIndex += 1;
      // Add the new data to the filtered items array
      filteredItems.push(resdata);
    });

    // Update the state with the new table data
    setTableData(filteredItems);
    setRowsId(rows_id + selectedArray.length); // Update the row ID accordingly
  };

  const [selectionLoading, setSelectionLoading] = useState({});

  useEffect(() => {
    if (projectId) {
      const fetchData = async () => {
        try {
          // setLoading(true);

          for (const selection of selectionDetails) {
            const selectionId = selection.selectionId;

            setSelectionLoading(prev => ({
              ...prev,
              [selectionId]: true
            }));

            const response = await UserSection.editProject({
              projectId,
              selectionId,
            });
            const newData = [];
            setselectionClient(response.data.client_id);
            if (selectionId === 1) setSelectedDate(response.data.valid_date);

            Object.keys(response.data.section).forEach((sectionKey) => {
              let fixedGst = response.data.section[selectionId][0].gst;
              let totalGst = fixedGst ? 1 : 0;

              setGst(totalGst);
              setAmountType(response.data.section[selectionId][0].type);

              response.data.section[sectionKey].forEach((item) => {
                const productData = item.product_attr;
                newData.push({
                  edit_id: item.id,
                  id: item.id,
                  check: false,
                  sku_code: item.sku_code,
                  brand: productData.brand,
                  product_desc: productData.product_desc,
                  finish: productData.finish || "",
                  image: productData.image || "",
                  quantity: item.qty,
                  area: item.area,
                  collection: item.product_attr.collection,
                  mrp: productData.mrp,
                  discount_price: item.disc_price,
                  discount_per: item.disc_per,
                  // gst: gst == 1 ? productData.gst : 0,
                  gst: totalGst ? item.product_attr.gst : 0,
                  total: item.total || 0,
                  discount: "",
                  selection: item.section_id,
                  active: item.section_id === selectionId,
                  selection_name: item.section_name,
                  check_gst: productData.gst,
                  active: true,
                  type: "update",
                  Spare: productData.spare_fg,
                  Group: productData.product_typ_group,
                  unit: item.unit,
                  copy_id: item.copy_id,
                  hsnCode: productData.hsnCode,
                  category: productData.category,
                  priceSegment: productData.priceSegment,
                  spare_fg: productData.spare_fg,
                  project_details_id: item.project_details_id,
                  stock: productData?.stock?.stockAvailable || 0,
                  stockIndicator: productData?.stock?.stockIndicator || "N/A"
                });
              });
            });

            const selectedItem = newData.find(
              (item) => item.selection == selectionId
            );

            const newSecName = selectedItem
              ? selectedItem.selection_name || ""
              : "";
            setSecName(newSecName);

            const mappedNewData = newData.map((item) => ({
              id: item.id,
              check: item.check,
              sku_code: item.sku_code,
              brand: item.brand,
              product_desc: item.product_desc,
              finish: item.finish,
              image: item.image,
              quantity: item.quantity,
              area: item.area,
              mrp: item.mrp,
              collection: item.collection,
              discount_price: item.discount_price,
              discount_per: item.discount_per,
              gst: gst == 1 ? item.gst : 0,
              total: item.total,
              discount: item.discount,
              selection: item.selection,
              active: item.active,
              selection_name: item.selection_name,
              client_id: null,
              type: item.type,
              check_gst: item.check_gst,
              Spare: item.Spare,
              Group: item.Group,
              unit: item.unit,
              copy_id: item.copy_id,
              hsnCode: item.hsnCode,
              category: item.category,
              priceSegment: item.priceSegment,
              spare_fg: item.spare_fg,
              project_details_id: item.project_details_id,
              stock: item?.stock || 0,
              stockIndicator: item?.stockIndicator || 'N/A',
            }));

            setTableData((prev) => {
              const updatedData = [...prev, ...mappedNewData];
              return updatedData.filter(
                (item) => item.sku_code !== "" && item.sku_code !== null
              );
            });
            setSelectionLoading(prev => ({
              ...prev,
              [selectionId]: false
            }));
            setSecName(selectionDetails[0]?.selectionName)
          }

        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchData();
    }
  }, [projectId]);


  const ClientList = async () => {
    try {
      const response = await UserSection.allClients();
      if (response.status) {
        setClient(response.data);
      }
    } catch (error) {
      handleApiError(error, "Failed to fetch data. Please try again later.");
    }
  };
  const handleSelectChange = (option) => {
    if (option) {
      setselectionClient(option.value);
    }
  };



  const options = useMemo(() => {
    let baseOptions = clientsOption
      ? clientsOption.map((item) => ({
        value: item.id,
        label: `${item.client_name.toUpperCase()} - ${item.id}`,
      }))
      : [];

    if (!cid) return baseOptions;

    const exists = baseOptions.some((opt) => opt.value == cid);

    if (!exists && clientName) {
      baseOptions.push({
        value: cid,
        label: `${decodeURIComponent(clientName).toUpperCase()} - ${cid}`,
      });
    }

    return baseOptions;
  }, [clientsOption, cid, clientName]);

  const handleKeyUp = async (e, id, editId) => {
    if (!secName) {
      toast.warning("Add Selection Name Before Proceeding");
      return;
    } else if (!selectionClient) {
      toast.warning("Select Client Before Proceeding");
      return;
    }

    const updatedItems = [...tableData];
    const index = updatedItems.length;
    try {
      // alert(e.target.value);
      if (e.target.value != 0) {
        const updatedItems = [...tableData];

        // Find the index of the object with the matching id
        const index = updatedItems.findIndex((item) => item.id === id);

        if (editId) {
          setRemovedIds((prevRemovedIds) => [...prevRemovedIds, editId]);
        }

        const response = await UserSection.productBySkeu(e.target.value);
        if (response.status) {
          const stock = Number(response.data?.stock || 0);
          const qty = defaultValue?.qty ? Number(defaultValue.qty) : 1;

          if (stock === 0 || stock < qty) {
            const result = await Swal.fire({
              title: stock === 0 ? "Out of Stock" : "Low Stock",
              text: stock === 0
                ? "This product is out of stock. Do you still want to add it?"
                : `Only ${stock} units available, but you are adding ${qty}. Proceed?`,
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes, add it!",
              cancelButtonText: "No, cancel"
            });

            if (!result.isConfirmed) {
              return;
            }
          }

          // Update the object's properties
          if (index !== -1) {
            let hasgst;
            let unit_price =
              parseFloat(response.data.mrp * 100) /
              parseFloat(100 + response.data.gst);
            let unit_mrp = unit_price;
            let ref_total = response.data.mrp;
            if (gst == 1) {
              hasgst = response.data.gst;
              // let ref_total = parseFloat((hasgst * response.data.mrp) / 100);

              ref_total = parseFloat(response.data.mrp);
            } else {
              hasgst = 0;
              ref_total = parseFloat(unit_mrp);
            }
            let price_gst = 0;

            const getLartgest_Id = getLartgestId();
            const qty = defaultValue?.qty ? Number(defaultValue.qty) : 1;
            const discountPer = defaultValue?.discount_per
              ? Number(defaultValue.discount_per)
              : 0;
            const basePrice = gst == 1 ? response.data.mrp : unit_mrp;
            const discountPricePerUnit = parseFloat(
              ((basePrice * discountPer) / 100).toFixed(1)
            );
            const totalCalculated = parseFloat(
              ((basePrice * qty - discountPricePerUnit * qty) || 0).toFixed(1)
            );

            const resdata = {
              id: getLartgest_Id,
              check: false,
              sku_code: response.data.sku_code || "",
              brand: response.data.brand || "",
              product_desc: response.data.product_desc || "",
              finish: response.data.finish || "",
              image: response.data.image || "",
              quantity: qty,
              area: "",
              mrp: response.data.mrp || 0,
              discount_price: discountPricePerUnit,
              collection: response.data.collection || "",
              discount_per: discountPer,
              gst: gst == 1 ? response.data.gst : 0,
              total: formatNumber(totalCalculated),
              discount: 0,
              selection: selectionId,
              active: true,
              selection_name: secName || "",
              check_gst: response.data.gst || 0,
              Spare: response.data.spare_fg || "",
              Group: response.data.product_typ_group || "",
              unit: unit_mrp || 0,
              copy_id: 0,
              hsnCode: response.data.hsnCode || "",
              category: response.data.category || "",
              priceSegment: response.data.priceSegment || "",
              spare_fg: response.data.spare_fg || "",
              stock: response.data?.stock?.stockAvailable || 0,
              stockIndicator: response.data?.stock?.stockIndicator || "N/A"
            };

            updatedItems[index] = resdata;
            setTableData(updatedItems);
          }
        }
      }
    } catch (error) {
      handleApiError(error, "Failed to fetch data. Please try again later.");
    }
  };

  const Selection = async () => {
    try {
      const response = await UserSection.allselection();
      if (response.status) {
        setSelection(response.data);
      }
    } catch (error) {
      handleApiError(error, "Failed to fetch data. Please try again later.");
    }
  };

  const saveProjectData = async (e) => {
    let dataStatsu = false;
    dataStatsu = await errorValidation();
    if (dataStatsu == true) {
      if (!projectId) {
        Swal.fire({
          title: "Do you want to continue?",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "Yes, continue",
          cancelButtonText: "No, cancel",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
        }).then((result) => {
          if (result.isConfirmed) {
            saveConfimed();
            setLoading(true);
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            setLoading(false);
          }
        });
      } else {
        Swal.fire({
          title: "Do you want to Save?",
          text: selectionClient == cid
            ? ""
            : "Client has changed. Updating the existing record is not permitted. You can try saving as new.",
          icon: "success",
          showCancelButton: selectionClient == cid,
          confirmButtonText: "Save New",
          cancelButtonText: "Update Existing",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
        }).then((result) => {

          if (result.isConfirmed) {
            const cidExists = clientsOption?.some(item => item.id == cid);
            if (!cidExists) {
              Swal.fire({
                icon: "warning",
                title: "Unauthorized",
                text: "You do not own this client. You can only do save new for your own clients.",
                confirmButtonText: "OK",
              });
              return;
            }
            if (!selectedDate) {
              Swal.fire({
                icon: "warning",
                text: "Valid Date Required To Proceed",
                confirmButtonText: "OK",
              });
              return false;
            }
            saveConfimed();
            setLoading(true);
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            if (!selectedDate) {
              Swal.fire({
                icon: "warning",
                text: "Valid Date Required To Proceed",
                confirmButtonText: "OK",
              });
              return false;
            }
            updateConfimed();
            setLoading(false);
          }
        });
      }
    } else {
      return 0;
    }
  };
  const [currentStep, setCurrentStep] = useState(0);
  const [totalStep, setTotalStep] = useState(0);
  const [progress, setProgress] = useState(0);

  const generateProjectId = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    const projectId = `${year}${month}${day}${hours}${minutes}${seconds}`;

    return projectId;
  };

  const saveConfimed = async () => {
    const PID = generateProjectId();
    // const client_name_for_PID = clientsOption?.find((client) => client.id == selectionClient)?.client_name.replace(/[\/\\\.]/g, "")?.toUpperCase();
    const client_name_for_PID = clientsOption?.find((client) => client.id == selectionClient)
      ?.client_name
      .replace(/[\/\\\.]/g, "")  // 1. Remove slashes and dots
      .replace(/\s+/g, "_")      // 2. Replace spaces with _
      ?.toUpperCase();

    try {
      setLoading(true);
      setProgress(true);

      const filteredItems = tableData
        .filter((item) => item.sku_code !== "")
        .map(({ image, ...rest }) => rest);
      const groupedBySelection = filteredItems.reduce((acc, item) => {
        acc[item.selection] = acc[item.selection] || [];
        acc[item.selection].push(item);
        return acc;
      }, {});

      const selectionOrder = Object.keys(groupedBySelection).sort(
        (a, b) => a - b
      );
      setTotalStep(selectionOrder.length);

      for (const selection of selectionOrder) {
        const itemsToSend = groupedBySelection[selection]?.map(({ image, ...rest }) => rest);

        const mergedState = {
          tableData: itemsToSend,
          // tableData,
          selectionId,
          selectionClient,
          amountType,
          selectedDate,
          quatationId: `P_${client_name_for_PID}_${PID}`,
          draftId,
        };

        const response = await UserSection.saveProductData(mergedState);
        setDraftId("");
        setTableData([
          {
            id: rows_id,
            check: false,
            sku_code: "",
            brand: "",
            brand_description: "",
            finish: "",
            image: "",
            quantity: "",
            area: "",
            mrp: "",
            collection: "",
            discount_price: null,
            discount_per: null,
            gst: "",
            total: "",
            discount: "",
            selection: selectionId,
            active: true,
            selection_name: null,
            client_id: null,
            type: "add",
            check_gst: "",
            unit: 0,
            copy_id: 0,
            hsnCode: "",
            category: "",
            priceSegment: "",
            spare_fg: "",
          },
        ]);

        if (!response) {
          throw new Error(`Failed to save data for selection: ${selection}`);
        }

        setCurrentStep((prevStep) => prevStep + 1);
      }

      Swal.fire({
        title: "Success",
        icon: "success",
        html: `
           <div>
             <label>Project added successfuly</label> </br>
             <label>Project ID:</label>
             <span>P_${client_name_for_PID}_${PID}</span> </br>
             <label>Go To Summary To View Quotation</label>
            </div>
        `,
        showConfirmButton: true,
        confirmButtonText: "OK",
      }).then((result) => {
        if (result.isConfirmed) {
          // removeState();
          setClient("");
          setselectionClient("");
          setSecName("");

          window.location.href = "/user/projects";
        }
      });

      setTimeout(() => {
        window.location.href = "/user/projects";
      }, 30000);
    } catch (error) {
      handleApiError(error, "Failed to process data. Please try again later.");
    } finally {
      setLoading(false);
      setTimeout(() => {
        setProgress(false);
      }, 2000);
    }
  };

  const updateConfimed = async () => {
    try {
      const filteredItems = [...tableData];
      const updatedItems = filteredItems.filter((item) => item.sku_code !== "");

      await setTableData(updatedItems);
      setLoading(true);
      const filteredTableData = tableData.map(({ image, ...rest }) => rest);
      const mergedState = {
        tableData: filteredTableData,
        selectionClient,
        projectId,
        removedIds,
        amountType,
        selectedDate,
        selectionHistoryForEdit,
      };
      const response = await UserSection.updateProductData(mergedState);
      setDraftId("");
      setTableData([
        {
          id: rows_id,
          check: false,
          sku_code: "",
          brand: "",
          brand_description: "",
          finish: "",
          image: "",
          quantity: "",
          area: "",
          mrp: "",
          collection: "",
          discount_price: null,
          discount_per: null,
          gst: "",
          total: "",
          discount: "",
          selection: selectionId,
          active: true,
          selection_name: null,
          client_id: null,
          type: "add",
          check_gst: "",
          unit: 0,
          copy_id: 0,
          hsnCode: "",
          category: "",
          priceSegment: "",
          spare_fg: "",
        },
      ]);

      if (response.status) {
        setLoading(false);
        Swal.fire({
          title: "success",
          icon: "success",
          html: `
                        <div>
                        <label>Project Update successfuly</label> </br>
                        <label>Project ID:</label>
                        <span>${response.project_id}</span>
                        </div>
                    `,

          showConfirmButton: true,
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.isConfirmed) {
            removeState();
            setClient("");
            setselectionClient("");
            setSecName("");
            setLoading(false);

            // document.getElementById('clientId').value = '';
            // document.getElementById('sku_code');
            window.location.href = "/user/projects";
          }
          setLoading(false);
        });

        setTimeout(() => {
          window.location.href = "/user/projects";
        }, 30000);
      }
    } catch (error) {
      setLoading(false);
      handleApiError(error, "Failed to fetch data. Please try again later.");
    }
  };

  const errorValidation = async () => {
    let updatedItems = [...tableData];
    let errorMessages = []; // Array to collect error messages

    if (selectionClient) {
      // Create a map to track selection names for each selection
      const selectionNamesMap = {};

      if (!selectedDate) {
        Swal.fire({
          icon: "warning",
          text: "Valid Date Required To Proceed",
          confirmButtonText: "OK",
        });
        return false;
      }

      // Populate the selectionNamesMap with selection names
      updatedItems.forEach((item) => {
        if (item.sku_code !== "") {
          const selectionId = item.selection;
          const selectionName = item.selection_name;

          // If the selection ID is not in the map, add it
          if (!selectionNamesMap[selectionId]) {
            selectionNamesMap[selectionId] = selectionName;
          }
          // else if (selectionNamesMap[selectionId] !== selectionName) {
          //   // If there's a mismatch in selection names for the same selection ID
          //   errorMessages.push({
          //     message: `Selection name mismatch for SKU: ${item.sku_code} in Selection: ${selectionId}. Expected: ${selectionNamesMap[selectionId]}, Found: ${selectionName}`,
          //     sku_code: item.id, //previously using sku code  so dont confuse with it
          //     selection: selectionId,
          //   });
          // }
        }
      });

      // Check if selection names are provided for each selection
      for (const [selectionId, selectionName] of Object.entries(
        selectionNamesMap
      )) {
        if (!selectionName) {
          errorMessages.push({
            message: `Selection name is required for Selection: ${selectionId}`,
            sku_code: "", //previously using sku code  so dont confuse with it
            selection: selectionId,
          });
        }
      }

      for (let i = 0; i < updatedItems.length; i++) {


        if (
          (updatedItems[i].sku_code !== "" &&
            updatedItems[i].selection === "") ||
          updatedItems[i].selection === null
        ) {
          errorMessages.push({
            message: `Selection required for SKU: ${updatedItems[i].sku_code} in Selection: ${updatedItems[i].selection}`,
            sku_code: updatedItems[i].id, //previously using sku code  so dont confuse with it
            selection: updatedItems[i].selection,
          });
        }

        if (
          (updatedItems[i].sku_code !== "" &&
            updatedItems[i].quantity === "") ||
          (updatedItems[i].sku_code !== "" && updatedItems[i].quantity === null)
        ) {
          errorMessages.push({
            message: `Quantity required for SKU: ${updatedItems[i].sku_code} in Selection: ${updatedItems[i].selection}`,
            sku_code: updatedItems[i].id, //previously using sku code  so dont confuse with it
            selection: updatedItems[i].selection,
          });
        }

        if (updatedItems[i].sku_code !== "" && updatedItems[i].mrp == 0) {
          errorMessages.push({
            message: `Check MRP (₹) of SKU: ${updatedItems[i].sku_code} in Selection: ${updatedItems[i].selection}`,
            sku_code: updatedItems[i].id, //previously using sku code  so dont confuse with it
            selection: updatedItems[i].selection,
          });
        }
        if (
          updatedItems[i].sku_code !== "" &&
          updatedItems[i].discount_price > updatedItems[i].mrp
        ) {
          errorMessages.push({
            message: `Discount price can't exceed MRP for SKU: ${updatedItems[i].sku_code} in Selection: ${updatedItems[i].selection}`,
            sku_code: updatedItems[i].id, //previously using sku code  so dont confuse with it
            selection: updatedItems[i].selection,
          });
        }

        if (
          updatedItems[i].sku_code !== "" &&
          updatedItems[i].discount_price === ""
        ) {
          // if (amountType !== "no") {
          //   errorMessages.push({
          //     message: `Discount price required for SKU: ${updatedItems[i].sku_code} in Selection: ${updatedItems[i].selection}`,
          //     sku_code: updatedItems[i].id, //previously using sku code  so dont confuse with it
          //     selection: updatedItems[i].selection,
          //   });
          // }
        }
      }

      // Example usage
      if (errorMessages.length > 0) {
        setErrorMessages(errorMessages);
        return;
      }
    } else {
      Swal.fire({
        icon: "warning",
        text: "Client Id Required",
        confirmButtonText: "OK",
      });
      return false;
    }
    return true;
  };

  const addRowNew = (newSelectionId = null) => {
    // Ensure the newSelectionId is set, fallback to selectionId if null
    if (newSelectionId === null) {
      newSelectionId = selectionId;
    }

    // Step 1: Count how many rows have the given selection
    let total_slot = tableData.filter(
      (row) => row.selection === newSelectionId
    ).length;

    // Step 2: Check if the row limit has been reached
    if (total_slot >= 300) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Rows Limit reached = 300",
      });
      return false; // Prevent adding a new row
    }

    // Step 3: Generate the new row ID based on your ID generation logic
    const getLartgest_Id = getLartgestId(); // Ensure this function returns the next available ID
    setRowsId(getLartgest_Id); // Update the rows_id state

    // Step 4: Create the new row object
    const newRow = {
      id: getLartgest_Id,
      check: false,
      sku_code: "",
      brand: "",
      brand_description: "",
      finish: "",
      image: "",
      quantity: "",
      area: "",
      mrp: "",
      discound_price: "",
      discound_per: "",
      gst: "",
      selection: newSelectionId,
      active: true,
      selection_name: "",
    };

    // Step 5: Update the table data (ensure state update is handled correctly)
    setTableData((prevTableData) => {
      // Use a functional update to ensure you're working with the most recent state
      return [...prevTableData, newRow]; // Append new row to the existing tableData
    });

    // Debugging output to verify the new row is added
  };

  const addRow = (newSelectionId = null) => {
    // e.preventDefault();
    var total_slot = 0;
    if (null == newSelectionId) {
      newSelectionId = selectionId;
    }
    for (let i = 0; i < tableData.length; i++) {
      if (tableData[i].selection == newSelectionId) {
        total_slot += 1;
      }
    }
    if (total_slot >= 300) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Rows Limit riched = 300 ",
      });
      return false;
    }
    // var row_id = tableData.length + 1;
    // let r_id = rows_id + 1;
    const getLartgest_Id = getLartgestId();
    setRowsId(getLartgest_Id);

    const newRow = {
      id: getLartgest_Id,
      check: false,
      sku_code: "",
      brand: "",
      brand_description: "",
      finish: "",
      image: "",
      quantity: "",
      area: "",
      mrp: "",
      discound_price: "",
      discound_per: "",
      gst: "",
      selection: newSelectionId,
      active: true,
      selection_name: "",
      copy_id: 0,
      hsnCode: "",
      category: "",
      priceSegment: "",
      spare_fg: "",
    };
    setTableData([...tableData, newRow]);
  };

  const defaultItem = [
    {
      id: rows_id,
      check: false,
      sku_code: "",
      brand: "",
      brand_description: "",
      finish: "",
      image: "",
      quantity: "",
      area: "",
      mrp: "",
      discount_price: "",
      discount_per: "",
      gst: "",
      total: "",
      discount: "",
      selection: selectionId,
      active: true,
      selection_name: null,
      client_id: null,
      type: "add",
      check_gst: "",
      hsnCode: "",
      category: "",
      priceSegment: "",
      spare_fg: "",
    },
  ];

  const removeRow = (e) => {
    e.preventDefault();

    if (tableData.length === 0) {
      return;
    }
    const checkedItems = tableData.filter((item) => item.check);

    if (checkedItems.length > 0) {

      const idsToRemove = checkedItems
        .filter((item) => item.edit_id)
        .map((item) => item.edit_id);

      setRemovedIds((prevRemovedIds) => [...prevRemovedIds, ...idsToRemove]);

      const updatedItems = tableData.filter((item) => !item.check);
      setTableData(updatedItems.length === 0 ? defaultItem : updatedItems);
    }
  };

  // ONE
  const removeRowOne = (e, id, editId) => {
    e.preventDefault();
    let removeId = [];
    if (tableData.length === 1) {
      setTableData(defaultItem);
      return;
    }
    const itemToRemove = tableData.find((item) => item.id === id);
    if (editId) {
      setRemovedIds((prevRemovedIds) => [...prevRemovedIds, editId]);
    }
    const updatedItems = tableData.filter((item) => item.id !== id);
    // removeId.push(updatedItems[id]);
    setTableData(updatedItems);
  };

  const resetState = () => {
    removeState();
    setSelectionID(0);
    setSecName();
    setselectionClient();
    setSub_Total(0);
    tableData[0].sku_code = "";
    window.location.href = "/user/projects";
  };
  const removeState = () => {
    // tableData[0].sku_code = "";
    setTableData([
      {
        id: 1,
        check: false,
        sku_code: null,
        brand: "",
        brand_description: "",
        finish: "",
        image: "",
        quantity: "",
        area: "",
        mrp: "",
        discount_price: "",
        discount_per: "",
        gst: "",
        total: "",
        discount: "",
        selection: selectionId,
        active: true,
        hsnCode: "",
        category: "",
        priceSegment: "",
        spare_fg: "",
      },
    ]);
  };
  const handleCheckboxChange = (status, id) => {
    const updatedItems = [...tableData];

    const index = updatedItems.findIndex((item) => item.id === id);
    if (index !== -1) {
      updatedItems[index].check = !updatedItems[index].check;
      setTableData(updatedItems);
    } else {
      console.warn("Item with id", id, "not found!");
    }
  };

  const changeformdataqtyOld = (e, index) => {
    if (e.target.value >= 0) {
      const updatedItems = [...tableData];

      const all_total = sub_Total;
      // const index = updatedItems.findIndex(item => item.id === id);
      updatedItems[index].quantity = e.target.value;
      let roundTotal = parseFloat(updatedItems[index].mrp * e.target.value);

      let gst = parseFloat((roundTotal * updatedItems[index].gst) / 100);
      roundTotal += gst;
      // const roundTotal = updatedItems[index].mrp * updatedItems[index].quantity * updatedItems[index].gst / 100;
      // roundTotal+=gst;
      updatedItems[index].total = parseFloat(
        roundTotal - updatedItems[index].discount
      );
      // updatedItems[index].total += updatedItems[index].total +gst;
      // all_total +  updatedItems[index].total;
      // updatedItems[index].total = updatedItems[index].total - updatedItems[index].discount;
      setSub_Total(all_total + updatedItems[index].total);
      setTableData(updatedItems);
      // updatePrice(index);
    } else {
      alert("1");
      const updatedItems = [...tableData];
      let roundTotal = parseFloat(updatedItems[index].mrp * 1);
      let gst = parseFloat((roundTotal * updatedItems[index].gst) / 100);
      roundTotal += gst;

      updatedItems[index].total = roundTotal;
      setTableData(updatedItems);
      return 0;
    }
  };

  const changeformdataqty = async (e, id, row) => {
    const newQuantity = e.target.value;
    if (newQuantity < 0) {
      // alert("Quantity must be greater than or equal to 0.");
      return resetItemToDefault(id);
    }

    // if (Number(newQuantity) > Number(row.stock)) {
    //   const result = await Swal.fire({
    //     title: 'Stock Warning',
    //     text: `Available stock is only ${row.stock}. Do you want to proceed?`,
    //     icon: 'warning',
    //     showCancelButton: true,
    //     confirmButtonColor: '#3085d6',
    //     cancelButtonColor: '#d33',
    //     confirmButtonText: 'Yes, proceed',
    //     cancelButtonText: 'No'
    //   });

    //   if (!result.isConfirmed) {
    //     return resetItemToDefault(id);
    //   }
    // }

    const index = tableData.findIndex((item) => item.id === id);

    if (index === -1) {
      console.error("Item not found with the provided ID");
      return; // Handle case where the item is not found
    }
    // Get the item to update
    const updatedItems = [...tableData];
    const item = updatedItems[index];

    let cal_mrp = gst == 1 ? item.mrp : item.unit;

    item.quantity = newQuantity;

    item.total = calculateItemTotal(
      cal_mrp,
      newQuantity,
      item.discount_price,
      item.discount
    );

    // Update tableData state and recalculate the subtotal
    setTableData(updatedItems);
    updateSubtotal(updatedItems);
  };

  // Utility function to calculate item total including GST and discount
  const calculateItemTotal = (mrp, quantity, discount_price, discount) => {
    let baseTotal = mrp * quantity;
    // let gstAmount = (baseTotal * gst) / 100;
    let total = baseTotal - discount_price * quantity;

    return parseFloat(formatNumber(total)); // Round to 2 decimal places for accuracy
  };

  // Utility function to reset an item when quantity is invalid
  const resetItemToDefault = (id) => {
    // Find the index of the item using the provided id
    const index = tableData.findIndex((item) => item.id === id);

    if (index === -1) {
      return; // Handle case where the item is not found
    }

    const updatedItems = [...tableData];
    const item = updatedItems[index];

    // Default quantity is 1 if invalid input is detected
    item.quantity = 1;
    item.total = calculateItemTotal(item.mrp, 1, item.gst, item.discount);

    // Update tableData state and recalculate the subtotal
    setTableData(updatedItems);
    updateSubtotal(updatedItems);
  };

  // Utility function to calculate the subtotal of all items
  const updateSubtotal = (items) => {
    const total = items.reduce((acc, item) => acc + item.total, 0);
    // setSub_Total(parseFloat(total.toFixed(2))); // Round to 2 decimal places
  };

  const updatePrice = (index) => {
    const updatedItems = [...tableData];
    let price;
    let qty = updatedItems[index].quantity;
    let dicPrice = updatedItems[index].discount_price;
    let discPer = updatedItems[index].discount_per;
    let disOnQty = dicPrice * qty;
    let total;

    if (gst == "1") {
      price = parseFloat(updatedItems[index].mrp);
    } else {
      price = parseFloat(updatedItems[index].unit);
    }
    total = price * qty;
    total -= disOnQty;
    updatedItems[index].total = total;
  };

  const changeAmountType = (e, id) => {
    let value = e.target.value || "0";
    let dis = 0;
    const index = tableData.findIndex((item) => item.id === id);
    let updatedItems = [...tableData];
    // if (e.target.value) {
    if (value > -1) {
      if (amountType == "no") {
        return 0;
      } else if (amountType == "price") {
        if (gst == "1") {
          updatedItems[index].discount_price = e.target.value;
          let discount_mrp = e.target.value * updatedItems[index].quantity;
          updatedItems[index].total = updatedItems[index].total - discount_mrp;
          // set discount price
          updatedItems[index].discount_per = (
            parseFloat(e.target.value * 100) / updatedItems[index].mrp
          ).toFixed(1);
        } else {
          updatedItems[index].discount_price = e.target.value;
          let discount_mrp = e.target.value * updatedItems[index].quantity;
          updatedItems[index].total = updatedItems[index].total - discount_mrp;
          // set discount price
          updatedItems[index].discount_per = (
            parseFloat(e.target.value * 100) / updatedItems[index].unit
          ).toFixed(1);
        }
        setTableData(updatedItems);
      } else {
        if (gst == "1") {
          let total = updatedItems[index].mrp * updatedItems[index].quantity;
          updatedItems[index].discount_per = e.target.value;
          let discountPrice = (updatedItems[index].mrp * e.target.value) / 100;
          updatedItems[index].discount_price = discountPrice.toFixed(1);
          updatedItems[index].total = total;
          let finalDicount = discountPrice * updatedItems[index].quantity;
          updatedItems[index].total -= finalDicount;
        } else {
          let total = updatedItems[index].unit * updatedItems[index].quantity;

          updatedItems[index].discount_per = e.target.value;
          let discountPrice = (updatedItems[index].unit * e.target.value) / 100;
          updatedItems[index].discount_price = discountPrice.toFixed(1);
          updatedItems[index].total = total;
          let finalDicount = discountPrice * updatedItems[index].quantity;
          updatedItems[index].total -= finalDicount;
        }
        setTableData(updatedItems);
      }

      // setTableData(updatedItems);

      // setSub_Total(updatedItems[index].sub_Total);
      updatePrice(index);
    }

    // }
    else {
      alert("Please select positive value");
      return 0;
    }
    // } else {
    //   updatedItems[index].discount_per = "";
    //   updatedItems[index].discount_price = "";
    //   // updatedItems.total =  updatedItems.total;
    //   setTableData(updatedItems);
    // }
  };

  const changeAmountTypeOld = (e, id) => {
    e.preventDefault();
    let value = e.target.value || "0";

    let dis = 0;
    const index = tableData.findIndex((item) => item.id === id);
    let updatedItems = [...tableData];
    // if (e.target.value) {
    if (value > -1) {
      if (amountType == "no") {
        return 0;
      } else if (amountType == "price") {
        updatedItems[index].discount_price = e.target.value;
        let discount_mrp = e.target.value * updatedItems[index].quantity;
        updatedItems[index].total = updatedItems[index].total - e.target.value;
        // set discount price
        updatedItems[index].discount_per =
          (e.target.value * 100) / updatedItems[index].mrp;
        setTableData(updatedItems);
      } else {
        let roundTotal = parseFloat(
          parseFloat(updatedItems[index].mrp) * updatedItems[index].quantity
        );
        updatedItems[index].discount_per = value;
        let totla_per = parseFloat((roundTotal * value) / 100);
        updatedItems[index].discount = totla_per;

        dis =
          (updatedItems[index].discount_per * updatedItems[index].mrp) / 100;

        updatedItems[index].discount_price = dis;
        setTableData(updatedItems);
      }

      // setTableData(updatedItems);

      // setSub_Total(updatedItems[index].sub_Total);
      // updatePrice(index);
    }

    // }
    else {
      alert("Please select positive value");
      return 0;
    }
    // } else {
    //   updatedItems[index].discount_per = "";
    //   updatedItems[index].discount_price = "";
    //   // updatedItems.total =  updatedItems.total;
    //   setTableData(updatedItems);
    // }
  };


  const changeGst = (id) => {
    setGst(id);
    let updatedItems = [...tableData];
    updatedItems = updatedItems.map((item, index) => {
      const total_gst = parseFloat(item.total * item.check_gst) / 100;
      if (gst == 1) {
        let product_total = parseFloat(item.unit * item.quantity);
        product_total -= item.discount_price ? item.discount_price : 0;
        item.total = product_total;
        let discountPrice = (item.unit * item.discount_per) / 100;
        item.discount_price = discountPrice * item.quantity;
        item.gst = 0;
      } else {
        let product_total = parseFloat(item.mrp * item.quantity);
        product_total -= item.discount_price ? item.discount_price : 0;
        item.total = product_total;
        item.gst = item.check_gst;
        let discountPrice = (item.mrp * item.discount_per) / 100;
        item.discount_price = discountPrice * item.quantity;
      }
      return item;
    });
    setTableData(updatedItems);
  };

  const setArea = (e, id) => {
    const updatedItems = [...tableData];
    const index = tableData.findIndex((item) => item.id === id);
    updatedItems[index].area = e;
    setTableData(updatedItems);
  };

  const changeSelection = (e) => {
    handleSelectionForEdit(e.target.value);
    let Row = 0;
    const newSelectionId = e.target.value;

    let updatedItems = [...tableData];

    let current_sel = "";
    var total_slots = "";
    setSecName("");
    setSelectionID(newSelectionId);
    for (let i = 0; i < updatedItems.length; i++) {
      // updatedItems[i].selection = newSelectionId
      if (updatedItems[i].brand == "") {
        total_slots += 1;
      }
      if (updatedItems[i].selection != newSelectionId) {
        updatedItems[i].active = false;
        setSecName("");
        setSub_Total("");
      } else if (updatedItems[i].selection == newSelectionId) {
        setSecName("");

        updatedItems[i].active = true;
        current_sel = updatedItems[i].selection_name
          ? updatedItems[i].selection_name
          : "";
        setSub_Total(updatedItems[i].sub_Total);
      }
      if (updatedItems[i].selection == newSelectionId) {
        // updatedItems[i].selection = newSelectionId
        Row += 1;
      }
    }

    setTableData(updatedItems);

    setSecName(current_sel);
    if (Row <= 0) {
      if (is_Empty(newSelectionId)) {
        addRow(newSelectionId);
      }
    }
  };

  const is_Empty = (newSelectionId) => {
    let updatedItems = [...tableData];
    let status = true;
    for (let i = 0; i < updatedItems.length; i++) {
      if (updatedItems[i].selection == newSelectionId) {
        status = false;
      }
      if (status == false) {
        break;
      }
    }
    return status;
  };
  const changesectionName = (e) => {
    const value = e.target.value;

    const invalidChars = /[*?:\\\/\[\]]/;

    if (invalidChars.test(value)) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Invalid Character",
        text: "Characters like * ? : \\ / [ ] are not allowed",
        showConfirmButton: false,
        timer: 5000,
      });
      return;
    }

    setSecName(value);

    let updatedItems = [...tableData];
    for (let i = 0; i < updatedItems.length; i++) {
      if (parseInt(updatedItems[i].selection) === parseInt(selectionId)) {
        updatedItems[i].selection_name = value;
      }
    }

    setTableData(updatedItems);
  };

  // upload excel
  const handleFileChange = (event) => {
    // if (!secName) {
    //   fileInputRef.current.value = null;
    //   toast.warning("Add Selection Name Before Proceeding");
    //   return;
    // }
    if (secName) {
      fileInputRef.current.value = null;
      toast.warning("Selection name not required");
      setSecName("");
      return;
    }
    if (!selectionClient) {
      fileInputRef.current.value = null;
      toast.warning("Select Client Before Proceeding");
      return;
    }

    const file = event.target.files[0];
    setFiles(file);

    const reader = new FileReader();
    let allSheetData = [];

    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      workbook.SheetNames.forEach((sheetName, index) => {
        const sheet = workbook.Sheets[sheetName];

        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        if (index == 0) {
          allSheetData[sheetName] = jsonData.slice(0);
        } else {
          allSheetData[sheetName] = jsonData.slice(0);
        }
      });

      const sectionsArray = Object.entries(allSheetData);
      // const dataString  = JSON.stringify(allSheetData);
      importcsvfile1(sectionsArray);

      setExcelData(sectionsArray);
      setError("");
    };

    fileInputRef.current.value = null;

    reader.readAsArrayBuffer(file);
  };

  const importcsvfile1 = async (data) => {
    try {
      let stop = false;
      for (const selection of data) {
        const selectionName = selection[0];
        const selectionData = selection[1];
        const rowCount = selectionData.length;

        if (rowCount > 300) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `${selectionName} has exceeded the row limit of 300. It has ${rowCount} rows.`, // Correct template string usage
          }).then((result) => {
            // You can handle the user's action here if needed, for example:
            if (result.isConfirmed) {
              window.location.href = "/user/projects";
            }
          });

          stop = true;
          break;
        } else {
          console.log(`${selectionName} has ${rowCount} rows.`);
        }
      }
      if (stop) {
        return;
      }
      const updatedItems = [...tableData];
      setLoading(true);

      if (excelData) {
        const large_id = getLartgestId();
        const importData = await UserSection.excelImport(data); // Make API call
        setLoading(false);


        const productsWithIssues = importData.data.filter((item) => {
          const stock = Number(item.stock?.stockAvailable ?? 0);
          return stock === 0;
        });

        if (productsWithIssues.length > 0) {
          const tableRows = productsWithIssues
            .map((p) => {
              const requestedQty = Number(p.qty ?? defaultValue?.qty ?? 1);
              const stock = Number(p.stock?.stockAvailable ?? 0);
              return `
            <tr style="border-bottom: 1px solid #eee;">
              <td style="padding: 10px; text-align: left; font-weight: 600; color: #444;">${p.sku_code}</td>
              <td style="padding: 10px; text-align: center; color: ${stock === 0 ? '#ef4444' : '#f59e0b'}; font-weight: bold;">
                ${stock}
              </td>
              <td style="padding: 10px; text-align: center; color: #666;">${requestedQty}</td>
            </tr>`;
            })
            .join("");

          const result = await Swal.fire({
            title: '<span style="color: #856404; font-size: 1.25rem;">Import Stock Warning</span>',
            html: `
          <div style="font-size: 0.9rem; color: #666; margin-bottom: 15px; text-align: left; line-height: 1.4;">
            The following items in your file have limited availability. Do you want to import them anyway?
          </div>
          <div style="max-height: 250px; overflow-y: auto; border: 1px solid #e2e8f0; border-radius: 8px;">
            <table style="width: 100%; border-collapse: collapse; font-family: sans-serif; font-size: 0.8rem;">
              <thead style="background-color: #f8fafc; position: sticky; top: 0; z-index: 10;">
                <tr>
                  <th style="padding: 12px 10px; text-align: left; border-bottom: 2px solid #e2e8f0; color: #1e293b;">SKU Code</th>
                  <th style="padding: 12px 10px; text-align: center; border-bottom: 2px solid #e2e8f0; color: #1e293b;">Available</th>
                  <th style="padding: 12px 10px; text-align: center; border-bottom: 2px solid #e2e8f0; color: #1e293b;">Requested</th>
                </tr>
              </thead>
              <tbody>${tableRows}</tbody>
            </table>
          </div>
        `,
            icon: "warning",
            width: "600px",
            showCancelButton: true,
            confirmButtonColor: "#2563eb",
            cancelButtonColor: "#64748b",
            confirmButtonText: "Yes, Import All",
            cancelButtonText: "Cancel Import",
            allowOutsideClick: false,
          });

          if (!result.isConfirmed) return;
        }


        let ref_total = 0;
        const has_gst = 0;

        const newData = importData.data.map((item, index) => {
          const qty = Number(item.qty ?? defaultValue?.qty ?? 1);
          const has_gst = gst == 1 ? Number(item.gst ?? 0) : 0;
          const unitPrice = gst == 1 ? Number(item.mrp ?? 0) : Number(item.unit ?? 0);

          const discountPer = Number(
            gst == 1
              ? (item.discount_per ?? defaultValue?.discount_per ?? 0)
              : (item.discount_per_non_gst ?? defaultValue?.discount_per ?? 0)
          );

          const discountPricePerUnit = Number(
            item.discount_price ??
            item.discount_price_non_gst ??
            ((unitPrice * discountPer) / 100).toFixed(1)
          );

          const total = parseFloat(
            ((unitPrice * qty) - discountPricePerUnit * qty).toFixed(1)
          );

          const selectionValue = item.section_id ?? selectionId;
          const activeFlag = selectionValue == selectionId;

          return {
            has_gst,
            ref_total: unitPrice * qty,
            id: large_id + (index + 1),
            check: false,
            sku_code: item.sku_code,
            brand: item.brand,
            product_desc: item.product_desc,
            finish: item.finish,
            image: item.image,
            quantity: qty,
            collection: item.collection,
            area: item.area,
            mrp: item.mrp,
            discount_price: discountPricePerUnit,
            discount_per: discountPer,
            gst: gst == 1 ? Number(item.gst ?? 0) : 0,
            total,
            discount: "",
            selection: selectionValue,
            active: activeFlag,
            selection_name: item.section_name ?? (activeFlag ? secName : ""),
            check_gst: item.gst,
            Group: item.product_typ_group,
            unit: item.unit,
            copy_id: 0,
            hsnCode: item.hsnCode,
            category: item.category,
            priceSegment: item.priceSegment,
            spare_fg: item.spare_fg,
            stock: item?.stock?.stockAvailable || 0,
            stockIndicator: item?.stock?.stockIndicator || "N/A",
          };
        });

        const combinedData = [...tableData, ...newData];
        if (
          updatedItems.length > 0 &&
          updatedItems[0] &&
          updatedItems[0].sku_code === ""
        ) {
          setTableData(newData);
          setRowsId(tableData.length);
        } else {
          const index = updatedItems.length;
          updatedItems[index] = newData;
          setRowsId(26);
        }

      } else {
        setError("Please select a file.");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const getLartgestId = () => {
    if (tableData.length === 0) {
      return 1;
    }

    const largestId = tableData.reduce((maxId, item) => {
      return Math.max(maxId, item.id);
    }, 0);

    return largestId + 1;
  };

  const downloadcsv = async (e) => {
    try {
      e.preventDefault();
      const url =
        "https://quotationsapis.groheapp.in/public/excel/sku_data.xlsx";
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = "sku_data.xlsx";
      anchor.click();
    } catch (error) {
      setLoading(true);
      console.log(error);
    }
  };

  let total_amount = 0;
  let total_quantity = 0;
  let total_discount_price = 0;

  const [areAllChecked, setAreAllChecked] = useState(false);

  const selectAll = () => {
    const updatedTableData = tableData.map((item) => {
      if (item.selection == selectionId) {
        return { ...item, check: !areAllChecked };
      }
      return item;
    });

    setTableData(updatedTableData);
    setAreAllChecked(!areAllChecked);
  };

  const removeErrorMessage = (skuCode) => {
    setErrorMessages((prevMessages) =>
      prevMessages.filter((msg) => msg.sku_code !== skuCode)
    );
  };

  const [disable, setDisable] = useState(false);

  useEffect(() => {
    const filteredData = tableData.filter(
      (item) => item.selection == selectionId
    );
    const allChecked = filteredData.every((item) => item.check == true);

    if (filteredData.length == 0) {
      setDisable(false);
    } else {
      setDisable(allChecked);
    }
  }, [tableData, selectionId]);

  const trash =
    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M20.5001 6H3.5" stroke="#d00606" stroke-width="1.5" stroke-linecap="round"></path> <path d="M18.8332 8.5L18.3732 15.3991C18.1962 18.054 18.1077 19.3815 17.2427 20.1907C16.3777 21 15.0473 21 12.3865 21H11.6132C8.95235 21 7.62195 21 6.75694 20.1907C5.89194 19.3815 5.80344 18.054 5.62644 15.3991L5.1665 8.5" stroke="#d00606" stroke-width="1.5" stroke-linecap="round"></path> <path d="M9.5 11L10 16" stroke="#d00606" stroke-width="1.5" stroke-linecap="round"></path> <path d="M14.5 11L14 16" stroke="#d00606" stroke-width="1.5" stroke-linecap="round"></path> <path d="M6.5 6C6.55588 6 6.58382 6 6.60915 5.99936C7.43259 5.97849 8.15902 5.45491 8.43922 4.68032C8.44784 4.65649 8.45667 4.62999 8.47434 4.57697L8.57143 4.28571C8.65431 4.03708 8.69575 3.91276 8.75071 3.8072C8.97001 3.38607 9.37574 3.09364 9.84461 3.01877C9.96213 3 10.0932 3 10.3553 3H13.6447C13.9068 3 14.0379 3 14.1554 3.01877C14.6243 3.09364 15.03 3.38607 15.2493 3.8072C15.3043 3.91276 15.3457 4.03708 15.4286 4.28571L15.5257 4.57697C15.5433 4.62992 15.5522 4.65651 15.5608 4.68032C15.841 5.45491 16.5674 5.97849 17.3909 5.99936C17.4162 6 17.4441 6 17.5 6" stroke="#d00606" stroke-width="1.5"></path> </g></svg>';
  const inserRandom =
    '<svg fill="#2d4e4d" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 885.389 885.389" xml:space="preserve" stroke="#2d4e4d"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M560.988,212.188c-179.2,0-324.4,145.2-324.4,324.4s145.2,324.4,324.4,324.4c179.2,0,324.4-145.2,324.4-324.4 S740.188,212.188,560.988,212.188z M745.789,570.188c0,11-9,20-20,20h-91.2c-11,0-20,9-20,20v91.2c0,11-9,20-20,20h-67.2 c-11,0-20-9-20-20v-91.2c0-11-9-20-20-20H386.188c-5.5,0-10-4.5-10-10v-77.199c0-11,9-20,20-20h91.201c11,0,20-9,20-20v-91.2 c0-11,9-20,20-20h67.2c11,0,20,9,20,20v91.2c0,11,9,20,20,20h91.2c11,0,20,9,20,20V570.188z"></path> <path d="M153.588,416.489c5.6,0.1,10.7-3.301,12.8-8.4l60.7-145.8c2-4.9,5.9-8.8,10.8-10.8l145.8-60.7c5.2-2.2,8.5-7.2,8.4-12.8 c-0.101-5.6-3.601-10.6-8.8-12.6l-364.4-140.1c-5.1-1.9-10.8-0.7-14.6,3.1l-0.3,0.3c-3.8,3.8-5,9.6-3.1,14.6l140.1,364.399 C142.988,412.989,147.988,416.489,153.588,416.489z"></path> </g> </g></svg>';

  const [dropDownData, setDropDownData] = useState([]);
  const [selectedFinish, setSelectedFinish] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSegment, setSelectedSegment] = useState(null);

  const [selectedSpare, setSelectedSpare] = useState([]);
  const [selectedCollection, setSelectedCollection] = useState(null);
  const token = localStorage.getItem("u_token");

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const data = await UserSection.allProduct();
        setDropDownData(data.data);
      } catch (error) {
        console.log(error.message);
      } finally {
      }
    };
    fetchProjects();
  }, [token]);

  const getFinishOptions = () => {
    if (!dropDownData || !Array.isArray(dropDownData)) {
      console.warn("Try again later.");
      return [];
    }

    const finishOptions = dropDownData.map((product) => ({
      value: product.finish,
      label: product.finish,
    }));

    const uniqueFinishOptions = [
      ...new Map(finishOptions.map((item) => [item.value, item])).values(),
    ];

    return uniqueFinishOptions.sort((a, b) => a.value.localeCompare(b.value));
  };

  const getCategoryOptions = () => {
    if (!dropDownData || !Array.isArray(dropDownData)) {
      console.warn("Try again later.");
      return [];
    }

    const categoryOptions = dropDownData.map((product) => ({
      value: product.category,
      label: product.category,
    }));

    const uniqueCategoryOptions = [
      ...new Map(categoryOptions.map((item) => [item.value, item])).values(),
    ];

    return uniqueCategoryOptions.sort((a, b) => a.value.localeCompare(b.value));
  };
  const getSegmentOptions = () => {
    if (!dropDownData || !Array.isArray(dropDownData)) {
      console.warn("Try again later.");
      return [];
    }

    const segmentOptions = dropDownData.map((product) => ({
      value: product.priceSegment,
      label: product.priceSegment,
    }));

    const uniqueSegmentOptions = [
      ...new Map(segmentOptions.map((item) => [item.value, item])).values(),
    ];

    return uniqueSegmentOptions.sort((a, b) => a.value.localeCompare(b.value));
  };

  // not spare actualy its data for type group
  const getSpareFgOptions = () => {
    const groupData = dropDownData.filter(
      (item) => item.collection === selectedCollection
    );
    const spareFgOptions = groupData?.map((product) => ({
      value: product.product_typ_group,
      label: product.product_typ_group,
    }));
    const uniqueSpareFgOptions = [
      ...new Map(spareFgOptions?.map((item) => [item.value, item])).values(),
    ];
    return uniqueSpareFgOptions
      .sort((a, b) => a.value.localeCompare(b.value))
      .filter((item) => item.value != "");
  };

  const getTypeWithFinish = () => {
    const groupData = dropDownData.filter(
      (item) => item.finish === selectedFinish
    );
    const spareFgOptions = groupData?.map((product) => ({
      value: product.product_typ_group,
      label: product.product_typ_group,
    }));
    const uniqueSpareFgOptions = [
      ...new Map(spareFgOptions?.map((item) => [item.value, item])).values(),
    ];
    return uniqueSpareFgOptions
      .sort((a, b) => a.value.localeCompare(b.value))
      .filter((item) => item.value != "");
  };

  const getTypeWithCatgeory = () => {
    const groupData = dropDownData.filter(
      (item) => item.category === selectedCategory
    );
    const spareFgOptions = groupData?.map((product) => ({
      value: product.product_typ_group,
      label: product.product_typ_group,
    }));
    const uniqueSpareFgOptions = [
      ...new Map(spareFgOptions?.map((item) => [item.value, item])).values(),
    ];
    return uniqueSpareFgOptions
      .sort((a, b) => a.value.localeCompare(b.value))
      .filter((item) => item.value != "");
  };
  const getTypeWithSegment = () => {
    const groupData = dropDownData.filter(
      (item) => item.priceSegment === selectedSegment
    );
    const spareFgOptions = groupData?.map((product) => ({
      value: product.product_typ_group,
      label: product.product_typ_group,
    }));
    const uniqueSpareFgOptions = [
      ...new Map(spareFgOptions?.map((item) => [item.value, item])).values(),
    ];
    return uniqueSpareFgOptions
      .sort((a, b) => a.value.localeCompare(b.value))
      .filter((item) => item.value != "");
  };

  const getCollectionOptions = () => {
    const collectionOptions = dropDownData.map((product) => ({
      value: product.collection,
      label: product.collection,
    }));
    const uniqueCollectionOptions = [
      ...new Map(collectionOptions?.map((item) => [item.value, item])).values(),
    ];
    return uniqueCollectionOptions.sort((a, b) =>
      a.value.localeCompare(b.value)
    );
  };

  const handleFilter = async () => {
    if (!selectedSpare) {
      toast.warn("Select Product Type Group", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
      });
      return;
    }
    if (!searchqty) {
      toast.warn("Quantity Required", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
      });
      return;
    }

    setLoading(true);
    try {
      let filteredData = dropDownData.filter((item) => {
        const isSpareMatch =
          !selectedSpare || selectedSpare.includes(item.product_typ_group); // Check if the item is in selectedSpare array
        const isFinishMatch = !selectedFinish || item.finish === selectedFinish;
        const isCollectionMatch =
          !selectedCollection || item.collection === selectedCollection;
        const isCategoryMatch =
          !selectedCategory || item.category === selectedCategory;
        const isSegmentMatch =
          !selectedSegment || item.priceSegment === selectedSegment;

        return (
          isSpareMatch &&
          isFinishMatch &&
          isCollectionMatch &&
          isCategoryMatch &&
          isSegmentMatch
        );
      });

      // } else {
      //   filteredData = dropDownData.filter(
      //     (item) =>
      //       selectedCollection === "" || item.collection === selectedCollection
      //   );
      // }
      let selection = selectionId;

      if (tableData.length + filteredData.length > 4500) {
        Swal.fire({
          icon: "warning",
          title: "Oops...",
          text: "Items Are Exceeding The Selections ",
        });
        // setLoading(false);
        return;
      }

      let currentSelectionLength = tableData.filter(
        (item) => item.selection == selection
      ).length;

      if (currentSelectionLength + filteredData.length > 300) {
        const exceedingItems =
          currentSelectionLength + filteredData.length - 300;
        Swal.fire({
          title: "Can't Proceed !",
          text: `Selection limit of 300 exceeded by ${exceedingItems} items. You can try adding them to another selection.`,
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK",
        }).then(() => {
          // setLoading(false);
        });
        return;
      } else {
        const large_id = getLartgestId();
        const newData = filteredData.map((item, index) => {
          let hasgst;
          let unit_price =
            parseFloat(item.mrp * 100) / parseFloat(100 + item.gst);
          let unit_mrp = unit_price;
          let ref_total;
          let dis_price;
          if (gst == "1") {
            hasgst = item.gst;
            dis_price =
              (parseFloat(item.mrp) * (percFilter ? percFilter : 0)) / 100;

            ref_total = item.mrp * searchqty;
            ref_total -= dis_price * searchqty;
          } else {
            hasgst = 0;
            dis_price =
              (parseFloat(unit_mrp) * (percFilter ? percFilter : 0)) / 100;

            ref_total = unit_mrp * searchqty;
            ref_total -= dis_price * searchqty;
          }
          return {
            id: large_id + (index + 1),
            check: false,
            sku_code: item.sku_code,
            brand: item.brand,
            product_desc: item.product_desc,
            finish: item.finish,
            collection: item.collection,
            image: item.image,
            quantity: Number(searchqty),
            area: "",
            mrp: item.mrp,
            discount_price: dis_price,
            discount_per: percFilter ? percFilter : "0",
            gst: gst == 1 ? item.gst : 0,
            total: ref_total,
            discount: "",
            selection: selection,
            active: true,
            selection_name: secName,
            client_id: null,
            type: "add",
            check_gst: item.gst,
            Spare: item.spare_fg,
            Group: item.product_typ_group,
            unit: unit_mrp,
            copy_id: 0,
            hsnCode: item.hsnCode,
            category: item.category,
            priceSegment: item.priceSegment,
            spare_fg: item.spare_fg,
            stock: item.stock?.stockAvailable || 0,
            stockIndicator: item.stock?.stockIndicator || "N/A",
          };
        });

        const updatedTableData = tableData.filter(
          (item) => item.sku_code !== "" && item.sku_code !== null
        );
        setSmartFilterProduct(newData);
        setExpandMore(false);
        setActiveTab(0);
        setSelectedCategory(null);
        setSelectedSegment(null);
        setSelectedCollection(null);
        setSelectedSpare(null);
        setSelectedFinish(null);
        toast.success(`${newData.length} Items Added Successfully!`);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const formatNumber = (value) => {
    let val = value ? value : 0;
    if (typeof val === "string") {
      val = val.replace(/,/g, "");
    }

    val = parseFloat(val);
    return val.toFixed(1);
  };

  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    // setSelectedSpare("");
    setSelectedSpare([]);
    setSelectedFinish("");
    setSelectedCollection("");
  };

  //custom option for product type select with checkbox
  const CustomOption = (props) => {
    const { data, innerRef, innerProps } = props;
    const isSelected = selectedSpare ? selectedSpare.includes(data.value) : "";

    return (
      <div
        ref={innerRef}
        {...innerProps}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0.5rem",
          cursor: "pointer",
        }}
      >
        <label>{data.label}</label>
        <input
          type="checkbox"
          checked={isSelected}
          readOnly
          style={{ marginLeft: "1rem" }}
        />
      </div>
    );
  };

  // Handle Change   for spare which is working for product type group
  const handleChangeSpare = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setSelectedSpare(selectedValues);
  };

  const saveAsDraft = async () => {
    const filteredTableData = tableData?.map(({ image, ...rest }) => rest);
    const mergedState = {
      tableData: filteredTableData,
      selectionId,
      selectionClient,
      amountType,
      selectedDate,
      removedIds,
    };
  
    try {
      setLoading(true);

      const result = await Swal.fire({
        title: "Do you want to Save?",
        icon: "success",
        showCancelButton: draftId ? true : false,
        confirmButtonText: "Save New",
        cancelButtonText: draftId ? "Update Existing" : "Cancel",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      });
      if (result.isConfirmed) {
        const response = await UserSection.saveAsDraff(mergedState);
        setDraftId("");
        setdraftData([""]);
        navigate("/user/draft");
        localStorage.setItem(
          "selectionHistory",
          JSON.stringify([
            ...JSON.parse(localStorage.getItem("selectionHistory") || "[]"),
            { [response.project_id]: selectionHistory },
          ])
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        if (!draftData) {
          const response = await UserSection.saveAsDraff(mergedState);
          setDraftId("");
          setdraftData([""]);
          navigate("/user/draft");
          localStorage.setItem(
            "selectionHistory",
            JSON.stringify([
              ...JSON.parse(localStorage.getItem("selectionHistory") || "[]"),
              { [response.project_id]: selectionHistory },
            ])
          );
        } else {
          let projectId = draftData ? draftData.data.id : "";
          const mergedState = {
            tableData,
            selectionId,
            selectionClient,
            amountType,
            selectedDate,
            removedIds,
            projectId,
          };
          const response = await UserSection.updateDraft(mergedState);
          setDraftId("");
          setDraftId("");
          setdraftData([null]);
          navigate("/user/draft");
          localStorage.setItem(
            "selectionHistory",
            JSON.stringify([
              ...JSON.parse(localStorage.getItem("selectionHistory") || "[]"),
              { [response.project_id]: selectionHistory },
            ])
          );
        }
      }
    } catch (error) {
      console.error("Error in saving draft:", error);

      Swal.fire(
        "Error",
        "Something went wrong while saving the draft",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const [lastActivityTime, setLastActivityTime] = useState(Date.now());
  const hasLoggedRef = useRef(false);

  const handleMouseMove = () => {
    setLastActivityTime(Date.now());
    hasLoggedRef.current = false;
  };

  useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove);

    const inactivityInterval = setInterval(() => {
      if (
        // Date.now() - lastActivityTime >= 1 * 60 * 1000 &&
        Date.now() - lastActivityTime >= 20000 &&
        !hasLoggedRef.current
      ) {
        tableData.some((row) => row.sku_code != "") && autoSaveDraft();
        hasLoggedRef.current = true;
      }
    }, 1000);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      clearInterval(inactivityInterval);
    };
  }, [lastActivityTime]);


  const autoSaveDraft = async () => {
    try {
      setLoading(true);

      if (!draftId) {
        const mergedState = {
          tableData,
          selectionId,
          selectionClient,
          amountType,
          selectedDate,
          removedIds,
        };
        const response = await UserSection.saveAsDraff(mergedState);
        setTimeout(() => {
          setDraftId(response.project_id);
        }, 2000);
        localStorage.setItem(
          "selectionHistory",
          JSON.stringify([
            ...JSON.parse(localStorage.getItem("selectionHistory") || "[]"),
            { [response.project_id]: selectionHistory },
          ])
        );
      } else if (draftId && getStatus === "succeeded") {
        let projectId = draftData ? draftData.data.id : "";
        const mergedState = {
          tableData,
          selectionId,
          selectionClient,
          amountType,
          selectedDate,
          removedIds,
          projectId,
        };
        const response = await UserSection.updateDraft(mergedState);

        const storedSelectionHistory = JSON.parse(
          localStorage.getItem("selectionHistory") || "[]"
        );
        const existingIndex = storedSelectionHistory.findIndex(
          (item) => Object.keys(item)[0] === response.project_id
        );
        if (existingIndex !== -1) {
          storedSelectionHistory.splice(existingIndex, 1);
        }
        localStorage.setItem(
          "selectionHistory",
          JSON.stringify([
            ...storedSelectionHistory,
            { [response.project_id]: selectionHistory },
          ])
        );
        // setDraftId('');
        // setDraftId('');
        // setdraftData([null]);
        // navigate("/user/draft");
      }
    } catch (error) {
      console.error("Error in saving draft:", error);

      Swal.fire(
        "Error",
        "Something went wrong while saving the draft",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const sectionOptions = Array.from(
    new Map(
      tableData
        .filter(
          (item) =>
            item.sku_code !== "" &&
            item.brand !== "" &&
            item.selection != selectionId
        )
        .map((item) => [
          item.selection,
          { label: item.selection_name, value: item.selection },
        ])
    ).values()
  );

  const copyOptions = sectionOptions?.map((item) => ({
    label: item.label || "",
    value: item.value || "",
  }));

  const CustomOptions = (props) => {
    const { data, innerRef, innerProps } = props;
    const isChecked = selectionHistory?.[selectionId]?.selection.includes(
      data.value
    );

    return (
      <components.Option {...props}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "8px 12px",
            width: "100%",
          }}
        >
          <input
            type="checkbox"
            onChange={() => copySelectionData(data.value)}
            style={{
              marginRight: "12px",
              width: "16px",
              height: "16px",
              accentColor: "#6366f1", // Modern checkbox styling
              cursor: "pointer",
            }}
            ref={innerRef}
            checked={isChecked}
            {...innerProps}
          />
          <span
            style={{
              color: isChecked ? "#4338ca" : "#4b5563",
              fontWeight: isChecked ? "500" : "normal",
            }}
          >
            {data.label}
          </span>
        </div>
      </components.Option>
    );
  };
  const handleSelectionHistory = (selectionId, selection) => {
    // if (!secName) {
    //   toast.warning("Add Selection Name Before Proceeding");
    //   return;
    // } else if (!selectionClient) {
    //   toast.warning("Select Client Before Proceeding");
    //   return;
    // }
    setSelectionHistory((prevHistory) => {
      if (prevHistory[selectionId]) {
        const currentSelections = prevHistory[selectionId].selection;

        if (currentSelections.includes(selection)) {
          return {
            ...prevHistory,
            [selectionId]: {
              selection: currentSelections.filter((item) => item != selection),
            },
          };
        } else {
          return {
            ...prevHistory,
            [selectionId]: {
              selection: [...currentSelections, selection],
            },
          };
        }
      } else {
        return {
          ...prevHistory,
          [selectionId]: { selection: [selection] },
        };
      }
    });
  };

  const copySelectionData = (data) => {
    const currentSelectionDataCount = tableData?.filter(
      (row) => row.selection === selectionId
    )?.length;
    if (currentSelectionDataCount >= 300) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Rows Limit reached = 300",
      });
      return false;
    }

    setselectionClient(selectionClient);
    if (!secName) {
      toast.warning("Add Selection Name Before Proceeding");
      return;
    } else if (!selectionClient) {
      toast.warning("Select Client Before Proceeding");
      return;
    }

    handleSelectionHistory(selectionId, data);
    const filteredData = tableData.filter((item) => item.selection == data);

    const newData = filteredData.map((item, index) => {
      const large_id = getLartgestId();
      return {
        id: large_id + (index + 1),
        check: false,
        sku_code: item.sku_code,
        brand: item.brand,
        product_desc: item.product_desc,
        finish: item.finish,
        collection: item.collection,
        image: item.image,
        quantity: item.quantity,
        area: item.area,
        mrp: item.mrp,
        discount_price: item.discount_price ? item.discount_price : "0",
        discount_per: item.discount_per ? item.discount_per : "0",
        gst: item.gst,
        discount: "",
        selection: selectionId,
        active: true,
        selection_name: secName,
        client_id: selectionClient,
        type: "add",
        check_gst: item.gst,
        Spare: item.spare_fg,
        Group: item.Group,
        total: item.total,
        unit: item.unit,
        copy_id: selectionHistory?.[selectionId]?.selection.includes(data)
          ? item.copy_id
          : `${selectionId}_${data}`,
        hsnCode: item.hsnCode,
        category: item.category,
        priceSegment: item.priceSegment,
        spare_fg: item.spare_fg,
        stock: item.stock || 0,
        stockIndicator: item.stockIndicator || "N/A",
      };
    });

    if (selectionHistory?.[selectionId]?.selection.includes(data)) {
      setTableData((prevData) => {
        return prevData.filter(
          (item) => item.copy_id != `${selectionId}_${data}`
        );
      });
    } else {
      setTableData((prevData) => {
        const combinedData = [...prevData, ...newData];
        return combinedData.filter((item) => {
          return item.sku_code !== "" && item.brand !== "";
        });
      });
    }
  };

  useEffect(() => {
    if (draftId) {
      const storedSelectionHistory = localStorage.getItem("selectionHistory");
      if (storedSelectionHistory) {
        const parsedSelectionHistory = JSON.parse(storedSelectionHistory);
        const foundSelectionHistory = parsedSelectionHistory.find(
          (item) => Object.keys(item)[0] === draftId
        );
        if (foundSelectionHistory) {
          setSelectionHistory(foundSelectionHistory[draftId]);
        }
      }
    }
  }, [draftId]);

  const formatIndianNumber = (num, options = {}) => {
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 1,
      minimumFractionDigits: 1,
      ...options,
    });
  };

  const sortDataTable = () => {
    setLoading(true);
    try {
      let sortedData = [...tableData];

      const selectionRows = tableData.filter(
        (row) => row.selection == selectionId
      );
      const hasArea = selectionRows.some(
        (row) => row.area && row.area.trim() !== ""
      );
      if (hasArea) {
        sortedData = [
          ...tableData.filter((row) => row.selection != selectionId),
          ...selectionRows
            .slice()
            .sort((a, b) => {
              const brandA = (a.brand || "").toLowerCase();
              const brandB = (b.brand || "").toLowerCase();
              if (brandA < brandB) return -1;
              if (brandA > brandB) return 1;

              const areaA = a.area ? a.area.trim().toLowerCase() : "";
              const areaB = b.area ? b.area.trim().toLowerCase() : "";

              if (!areaA && !areaB) return 0;
              if (!areaA) return 1;
              if (!areaB) return -1;

              return areaA.localeCompare(areaB);
            }),
        ];
      } else {
        sortedData = [
          ...tableData.filter((row) => row.selection != selectionId),
          ...selectionRows.sort((a, b) => {
            const aKey = (
              (a.brand || "") + (a.priceSegment || "")
            ).toLowerCase();
            const bKey = (
              (b.brand || "") + (b.priceSegment || "")
            ).toLowerCase();
            return aKey.localeCompare(bKey);
          }),
        ];
      }
      setTableData(sortedData);
    } catch (error) {
      console.error("Error while sorting table data:", error);
    } finally {
      setLoading(false);
    }
  };

  const [selectionHistoryForEdit, setSelectionHistoryForEdit] = useState([1]);
  const handleSelectionForEdit = (selection) => {
    if (projectId) {
      setSelectionHistoryForEdit((prev) => {
        if (!prev.includes(selection)) {
          return [...prev, selection];
        }
        return prev;
      });
    }
  };

  const inserRandomRow = (id) => {
    const large_id = getLartgestId();
    const newRow = {
      id: large_id + 1,
      check: false,
      sku_code: "",
      brand: "",
      product_desc: "",
      finish: "",
      collection: "",
      image: "",
      quantity: 1,
      area: "",
      mrp: 0,
      discount_price: 0,
      discount_per: "0",
      gst: 0,
      total: 0,
      discount: "",
      selection: selectionId,
      active: true,
      selection_name: secName,
      client_id: selectionClient,
      type: "add",
      check_gst: 0,
      Spare: "",
      Group: "",
      unit: 0,
      copy_id: 0,
      hsnCode: "",
      category: "",
      priceSegment: "",
    };

    setTableData((prevData) => {
      const updatedData = [...prevData];

      const targetIndex = updatedData.findIndex(row => row.id === id);

      if (targetIndex !== -1) {
        updatedData.splice(targetIndex + 1, 0, newRow);
      } else {
        updatedData.push(newRow);
      }

      return updatedData;
    });
  };

  useEffect(() => {
    setsearchqty(defaultValue.qty);
    setPercFilter(defaultValue.discount_per);
  }, [defaultValue]);

  const [activeSku, setActiveSku] = useState(null);
  const hoverTimeout = useRef(null);

  const handleMouseEnter = (rowId, sku) => {
    clearTimeout(hoverTimeout.current);
    setActiveSku(sku);
  };

  const handleMouseLeave = () => {
    clearTimeout(hoverTimeout.current);
    hoverTimeout.current = setTimeout(() => {
      setActiveSku(null);
    }, 300);
  };

  useEffect(() => {
    setTableData((prevData) =>
      prevData.map((item) => {
        const qty = Number(item.quantity) || 1;
        const discountPer = Number(item.discount_per) || 0;

        const basePrice = gst == 1 ? Number(item.mrp) : Number(item.unit);

        const discountPricePerUnit = parseFloat(
          ((basePrice * discountPer) / 100).toFixed(1)
        );

        const totalCalculated = parseFloat(
          ((basePrice * qty - discountPricePerUnit * qty) || 0).toFixed(1)
        );

        return {
          ...item,
          gst: gst == 1 ? item.gst : 0,
          discount_price: discountPricePerUnit,
          total: formatNumber(totalCalculated),
        };
      })
    );
  }, [gst]);

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={true}
      />

      <SelectionLoadingStatus
        selectionDetails={selectionDetails}
        selectionLoading={selectionLoading}
      />

      <StockLable data={tableData} currentSelection={selectionId} />

      <InventoryPopUp
        sku={activeSku}
        onMouseEnter={() => clearTimeout(hoverTimeout.current)}
        onMouseLeave={handleMouseLeave}
      />

      {errorMessages.length > 0 && (
        <NotificationDrawer
          initialErrorMessages={errorMessages}
          selectionId={selectionId}
          onRemoveMessage={removeErrorMessage}
        />
      )}
      <SmartFilterProductManager smartFilterProduct={smartFilterProduct} setSmartFilterProduct={setSmartFilterProduct} tableData={tableData} setTableData={setTableData} />
      <DefaultValueManagerModal defaultValuePopUp={defaultValuePopUp} setDefaultValuePopUp={setDefaultValuePopUp} defaultValue={defaultValue} setDefaultValue={setDefaultValue} />
      <UserTopbar heading="Create quotation" sidebar={isSidebarOpen} />
      {(loading || getStatus === "pending") && <Loader />}
      {(progress && totalStep) > 0 && (
        <Box
          sx={{
            position: "fixed",
            bottom: 16,
            right: 16,
            width: 100,
            bgcolor: "background.paper",
            boxShadow: 3,
            borderRadius: 2,
            p: 2,
            textAlign: "center",
          }}
        >
          <CircularProgress
            variant="determinate"
            value={(currentStep / totalStep) * 100}
            size={60}
          />
          <Typography variant="caption" sx={{ mt: 1 }}>
            {`${Math.round((currentStep / totalStep) * 100)}%`}
          </Typography>
        </Box>
      )}

      <div
        className={`z-10 sticky create_quote top-0    mb-2 border border-black bg-white/95 rounded-xl `}
      >
        <div className="md:flex justify-between items-center gap-x-3 w-full p-2 pb-0 ">
          <Autocomplete onSelected={handleSelected} />

          <div
            onClick={() => {
              if (!secName) {
                toast.warning("Add Selection Name Before Proceeding");
                return;
              } else if (!selectionClient) {
                toast.warning("Select Client Before Proceeding");
                return;
              }
              setExpandMore(!expandMore);
            }}
          >
            <SmartSearchButton />
          </div>

          <div className="flex justify-center gap-5">
            <Tooltip title="Add Row At Bottom" arrow>
              <button
                className={`relative overflow-hidden px-2 rounded-full py-2 bg-black border border-white text-white text-sm transition-all duration-300 focus:outline-none group w-28 hover:bg-white hover:border-black hover:text-black`}
                onClick={() => {
                  const currentSelectionDataCount = tableData.filter(
                    (row) => row.selection == selectionId
                  ).length;
                  if (
                    tableData.length > 200 &&
                    currentSelectionDataCount >= 300
                  ) {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Rows Limit reached = 300",
                    });
                    return false;
                  }
                  addRow();
                }}
                disabled={disable}
              >
                <span className="absolute inset-0 bg-white transform -translate-x-full transition-transform duration-300 group-hover:translate-x-0" />
                <span className="relative flex items-center justify-center gap-2">
                  <AddCircleOutline className="scale-110" />
                  Add Row
                </span>
              </button>
            </Tooltip>

            <button
              className={`relative overflow-hidden px-2 rounded-full py-2 bg-black border border-white text-white  text-sm transition-all duration-300 focus:outline-none group w-28 hover:bg-white hover:border-black hover:text-black`}
              onClick={(e) => removeRow(e)}
            >
              <span className="absolute inset-0 bg-white transform -translate-x-full transition-transform duration-300 group-hover:translate-x-0" />
              <span className="relative flex items-center justify-center ">
                <Delete className="scale-110" />
                Delete Row
              </span>
            </button>

            <button
              className={`relative overflow-hidden px-2 rounded-full py-1 bg-black border border-white text-white  text-sm transition-all duration-300 focus:outline-none group w-28 hover:bg-white hover:border-black hover:text-black`}
              onClick={(e) => resetState(e)}
            >
              <span className="absolute inset-0 bg-white transform -translate-x-full transition-transform duration-300 group-hover:translate-x-0" />
              <span className="relative flex items-center justify-center gap-2">
                <RotateLeftRoundedIcon className="scale-110" />
                Reset
              </span>
            </button>

            <button
              onClick={saveProjectData}
              disabled={Object.values(selectionLoading || {}).some(Boolean)}
              className={`relative overflow-hidden px-2 rounded-full py-1 bg-black border border-white text-white  text-sm transition-all duration-300 focus:outline-none group w-28 hover:bg-white hover:border-black hover:text-black`}
            >
              <span className="absolute inset-0 bg-white transform -translate-x-full transition-transform duration-300 group-hover:translate-x-0" />
              <span className="relative flex items-center justify-center gap-2">
                <SaveIcon className="scale-110" />
                {projectId ? "Update Quote" : "Save Quote"}
              </span>
            </button>
            <button
              onClick={saveAsDraft}
              disabled={Object.values(selectionLoading || {}).some(Boolean)}
              className={`relative overflow-hidden px-2 rounded-full py-1 bg-red-700 border border-white text-white  text-sm transition-all duration-300 focus:outline-none group w-28 hover:bg-white hover:border-black hover:text-black`}
            >
              <span className="absolute inset-0 bg-white transform -translate-x-full transition-transform duration-300 group-hover:translate-x-0" />
              <span className="relative flex items-center justify-center gap-2">
                <PostAddIcon className="scale-110" />
                {draftId ? "Update Draft" : "Save As Draft"}
              </span>
            </button>
            <Tooltip title="Sorts current selection by Brand and Area (or Price Segment if no Area is selected)" arrow>
              <button
                onClick={() => sortDataTable()}
                disabled={Object.values(selectionLoading || {}).some(Boolean)}
                className={`relative overflow-hidden px-2 rounded-full py-1 bg-green-700 border border-white text-white  text-sm transition-all duration-300 focus:outline-none group w-28 hover:bg-white hover:border-black hover:text-black`}
              >
                <span className="absolute inset-0 bg-white transform -translate-x-full transition-transform duration-300 group-hover:translate-x-0" />
                <span className="relative flex items-center justify-center gap-2">
                  <FilterListIcon className="scale-110" />
                  Sort Data
                </span>
              </button>
            </Tooltip>
          </div>


          <div className="flex border border-blue-950 pl-2 -pr-2 rounded-3xl bg-gray-100 items-center">
            <Tooltip title={"Set Default Values"} arrow>
              <IconButton
                color="primary"
                className="p-3  h-[3rem] w-[3rem]"
                onClick={() => setDefaultValuePopUp(true)}
              >
                <AccountBoxIcon className="text-slate-700 cursor-pointer scale-150 hover:scale-125" />
              </IconButton>
            </Tooltip>
            <Tooltip title={"Download Format"} arrow>
              <IconButton
                color="primary"
                className="p-3  h-[3rem] w-[3rem]"
                onClick={(e) => downloadcsv(e)}
              >
                <DownloadForOfflineIcon className=" cursor-pointer scale-150 hover:scale-125" />
              </IconButton>
            </Tooltip>
            <Tooltip title={"Upload File"} arrow>
              <label
                htmlFor="fileInput"
                className="inline-block px-4 py-2   rounded "
              >
                <DriveFolderUploadSharpIcon className="text-orange-600 cursor-pointer scale-150 hover:scale-125" />
                <input
                  id="fileInput"
                  className="hidden"
                  ref={fileInputRef}
                  type="file"
                  onChange={handleFileChange}
                />
              </label>
            </Tooltip>
          </div>
        </div>

        {expandMore && (
          <Modal
            open={expandMore}
            onClose={() => {
              // setExpandMore(false);
              // setsearchqty("");
              // setPercFilter("");
              // setSelectedCollection("");
              // setSelectedFinish("");
              // setSelectedSpare("");
            }}
            aria-labelledby="filter-modal-title"
            aria-describedby="filter-modal-description"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 500,
                bgcolor: "background.paper",
                boxShadow: 24,
                p: 4,
                borderRadius: "8px",
              }}
            >
              {/* <Typography
                      id="filter-modal-title"
                      variant="h6"
                      component="h2"
                      mb={2}
                      className="text-center font-semibold"
                    >
                      Filters
                    </Typography> */}

              {/* Tabs */}
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                variant="fullWidth"
                indicatorColor="primary"
                textColor="primary"
              >
                <Tab label="Collection & Group" />
                <Tab label="Finish & Group" />
                <Tab label="Category & Group" />
                <Tab label="Price Segement & Group" />
              </Tabs>

              {/* Tab Content */}
              {activeTab === 0 && (
                <div className="space-y-3 mt-4">
                  {/* Collection Selection */}
                  <Select
                    value={
                      selectedCollection
                        ? options.find(
                          (option) => option.value === selectedCollection
                        )
                        : null
                    }
                    onChange={(option) => setSelectedCollection(option.value)}
                    options={getCollectionOptions()}
                    placeholder="Select Collection"
                    isSearchable
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        padding: "0.3rem",
                        borderRadius: "0.28rem",
                      }),
                    }}
                  />
                  {/* Spare Selection with Collection */}
                  <Select
                    value={getSpareFgOptions().filter(
                      (option) =>
                        Array.isArray(selectedSpare) &&
                        selectedSpare.includes(option.value)
                    )}
                    onChange={handleChangeSpare}
                    options={getSpareFgOptions()}
                    placeholder="Select Product Type Group"
                    isSearchable
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ Option: CustomOption }}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        padding: "0.3rem",
                        borderRadius: "0.28rem",
                      }),
                    }}
                  />

                  {/* multiple select */}
                </div>
              )}

              {activeTab === 1 && (
                <div className="space-y-3 mt-4">
                  {/* Finish Selection */}
                  <Select
                    value={
                      selectedFinish
                        ? options.find(
                          (option) => option.value === selectedFinish
                        )
                        : null
                    }
                    onChange={(option) => setSelectedFinish(option.value)}
                    options={getFinishOptions()}
                    placeholder="Select Finish"
                    isSearchable
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        padding: "0.3rem",
                        borderRadius: "0.28rem",
                      }),
                    }}
                  />

                  {
                    <Select
                      value={getTypeWithFinish().filter((option) =>
                        selectedSpare.includes(option.value)
                      )}
                      onChange={handleChangeSpare}
                      options={getTypeWithFinish()}
                      placeholder="Select Product Type Group"
                      isSearchable
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{ Option: CustomOption }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          padding: "0.3rem",
                          borderRadius: "0.28rem",
                        }),
                      }}
                    />
                  }
                </div>
              )}

              {activeTab === 2 && (
                <div className="space-y-3 mt-4">
                  {/* Finish Selection */}
                  <Select
                    value={
                      selectedCategory
                        ? options.find(
                          (option) => option.value === selectedCategory
                        )
                        : null
                    }
                    onChange={(option) => setSelectedCategory(option.value)}
                    options={getCategoryOptions()}
                    placeholder="Select Category"
                    isSearchable
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        padding: "0.3rem",
                        borderRadius: "0.28rem",
                      }),
                    }}
                  />

                  {
                    <Select
                      value={getTypeWithCatgeory().filter((option) =>
                        selectedSpare.includes(option.value)
                      )}
                      onChange={handleChangeSpare}
                      options={getTypeWithCatgeory()}
                      placeholder="Select Product Type Group"
                      isSearchable
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{ Option: CustomOption }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          padding: "0.3rem",
                          borderRadius: "0.28rem",
                        }),
                      }}
                    />
                  }
                </div>
              )}

              {activeTab === 3 && (
                <div className="space-y-3 mt-4">
                  {/* Finish Selection */}
                  <Select
                    value={
                      selectedSegment
                        ? options.find(
                          (option) => option.value === selectedSegment
                        )
                        : null
                    }
                    onChange={(option) => setSelectedSegment(option.value)}
                    options={getSegmentOptions()}
                    placeholder="Select Price Segment"
                    isSearchable
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        padding: "0.3rem",
                        borderRadius: "0.28rem",
                      }),
                    }}
                  />

                  {
                    <Select
                      value={getTypeWithSegment().filter((option) =>
                        selectedSpare.includes(option.value)
                      )}
                      onChange={handleChangeSpare}
                      options={getTypeWithSegment()}
                      placeholder="Select Product Type Group"
                      isSearchable
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{ Option: CustomOption }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          padding: "0.3rem",
                          borderRadius: "0.28rem",
                        }),
                      }}
                    />
                  }
                </div>
              )}

              {/* Quantity and Discount Inputs */}
              <div className="space-y-3 mt-4">
                <TextField
                  type="number"
                  name="searchqty"
                  fullWidth
                  value={searchqty}
                  onChange={(e) => setsearchqty(e.target.value)}
                  placeholder="Enter Quantity"
                  variant="outlined"
                />

                <TextField
                  type="number"
                  name="percFilter"
                  fullWidth
                  value={percFilter}
                  onChange={(e) => setPercFilter(e.target.value)}
                  placeholder="Enter Discount (%)"
                  variant="outlined"
                />
                <div className=" flex gap-4">
                  {/* Apply Filters Button */}
                  <button
                    onClick={() => {
                      handleFilter();
                      handleDebounce();
                    }}
                    disabled={isDisabled}
                    className="relative overflow-hidden px-6 py-2 bg-white border border-blue-500 text-blue-500 font-semibold text-md transition-all duration-300 focus:outline-none group w-full rounded"
                  >
                    <span className="absolute inset-0 bg-blue-500 transform -translate-x-full transition-transform duration-300 group-hover:translate-x-0" />
                    <span className="relative  transition-colors duration-300 group-hover:text-white flex items-center justify-center gap-2">
                      {isDisabled ? (
                        <SyncIcon className="scale-125" />
                      ) : (
                        <ManageSearchIcon className="scale-125" />
                      )}
                      Apply
                    </span>
                  </button>
                  <button
                    onClick={() => {
                      // setPercFilter(defaultValue.discount_per || 0);
                      // setsearchqty(defaultValue.quantity || 1);
                      setSelectedCategory("");
                      setSelectedSegment("");
                      setSelectedCollection("");
                      setSelectedFinish("");
                      setSelectedSpare([]);
                      setActiveTab(0);
                    }}
                    disabled={isDisabled}
                    className="relative overflow-hidden px-6 py-2 bg-white border border-green-500 text-green-500 font-semibold text-md transition-all duration-300 focus:outline-none group w-full rounded"
                  >
                    <span className="absolute inset-0 bg-green-500 transform -translate-x-full transition-transform duration-300 group-hover:translate-x-0" />
                    <span className="relative  transition-colors duration-300 group-hover:text-white flex items-center justify-center gap-2">
                      <SearchOffIcon className="scale-125" />
                      Clear
                    </span>
                  </button>
                  <button
                    onClick={() => {
                      setExpandMore(false);
                      // setsearchqty(defaultValue.quantity || 1);
                      // setPercFilter(defaultValue.discount_per || 0);
                      setActiveTab(0);
                      setSelectedCategory("");
                      setSelectedSegment("");
                      setSelectedCollection("");
                      setSelectedFinish("");
                      setSelectedSpare([]);
                    }}
                    disabled={isDisabled}
                    className="relative overflow-hidden px-6 py-2 bg-white border border-red-500 text-red-500 font-semibold text-md transition-all duration-300 focus:outline-none group w-full rounded"
                  >
                    <span className="absolute inset-0 bg-red-500 transform -translate-x-full transition-transform duration-300 group-hover:translate-x-0" />
                    <span className="relative  transition-colors duration-300 group-hover:text-white flex items-center justify-center gap-2">
                      <CloseFullscreenIcon className="scale-125" />
                      Close
                    </span>
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
        )}

        <section className="md:flex justify-between items-center gap-x-3 w-full p-2 pt-0 pb-0 -mt-4 ">
          <select
            className="flex-1 max-w-[10rem] py-3 form-select rounded text-center mt-3"
            onChange={(e) => changeSelection(e)}
            name="selection"
            id="selection"
            required
            value={selectionId}
          >
            {selection &&
              selection.map((item) => (
                <option
                  key={item.id}
                  value={item.id}
                  className={item.id === selectionId ? "selected" : ""}
                >
                  {item.name}
                </option>
              ))}
          </select>

          <input
            type="text"
            name={`sectionName${selectionId}`}
            id={`sectionName${selectionId}`}
            className="flex-1 py-3 mt-3 form-text rounded text-black-500 text-center"
            onChange={(e) => changesectionName(e)}
            value={secName}
            placeholder="Enter Selection Name*"
          />
          {/* <div className={` ${projectId ? "hidden" : "flex-1"} mt-3`}> */}
          <div className={`mt-3`}>
            <Select
              className="py-3"
              isDisabled={Object.values(selectionLoading || {}).some(Boolean)}
              options={copyOptions}
              placeholder="Copy Selection"
              isSearchable
              components={{ Option: CustomOptions }}
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              styles={{
                control: (provided) => ({
                  ...provided,
                  padding: "0.3rem",
                  borderRadius: "6px",
                  borderColor: "#4A5568",
                  "&:hover": {
                    borderColor: "blue",
                  },
                  backgroundColor: "white",
                  minHeight: "44px",
                }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isSelected ? "#eef2ff" : "white",
                  color: state.isSelected ? "#4338ca" : "#4b5563",
                  "&:hover": {
                    backgroundColor: "#f3f4f6",
                  },
                }),
                menu: (provided) => ({
                  ...provided,
                  borderRadius: "6px",
                  boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
                }),
              }}
            />
          </div>

          <div className="flex-1 mt-3">
            <Select
              className="py-3"
              value={
                selectionClient
                  ? options.find((option) => option.value == selectionClient)
                  : null
              }
              onChange={handleSelectChange}
              options={options}
              placeholder="Select Client"
              isDisabled={cid ? !clientsOption?.some(item => item.id == cid) : false}
              isSearchable
              styles={{
                control: (provided) => ({
                  ...provided,
                  padding: "0.3rem",
                  borderRadius: "0.28rem",
                  backgroundColor: "white",
                  borderColor: "#4A5568",
                }),
              }}
            />
          </div>

          <fieldset className="border border-gray-900 bg-white rounded-md p-1 ">
            <legend className="text-gray-700 font-medium">Valid Upto</legend>
            <input
              type="date"
              value={selectedDate || ""}
              onChange={(e) => setSelectedDate(e.target.value)}
              className="py-0 w-[10rem] text-primary border border-white rounded-md focus:ring-white"
            />
          </fieldset>

          <fieldset className="border border-gray-900 bg-white rounded-md p-1">
            <legend className="text-gray-700 font-medium">GST * </legend>
            <div className="flex gap-x-3">
              <div className="flex items-center gap-x-1">
                <input
                  id="gstInclusive"
                  type="radio"
                  className="form-checkbox text-primary border-2 border-gray-400 rounded-md focus:ring-primary"
                  name="get"
                  value="1"
                  onChange={(e) => changeGst(1)}
                  checked={gst == 1 ? true : false}
                  disabled={Object.values(selectionLoading || {}).some(Boolean)}
                // disabled={
                //   gst  == 1
                //     ? true
                //     : false || tableData.some((row) => row.sku_code !== "")
                // }
                // disabled={
                //   tableData.some((row) => row.sku_code !== "") ? true : false
                // }
                ></input>
                <label htmlFor="gstInclusive">Inclusive </label>
              </div>
              <Tooltip
                title="Base price will be considered"
                arrow
              >
                <div className="flex items-center gap-x-1">
                  <input
                    id="gstExclusive"
                    type="radio"
                    className="form-checkbox  w-5 text-primary border-2 border-gray-400 rounded-md focus:ring-primary"
                    name="get"
                    value="0"
                    onChange={(e) => changeGst(0)}
                    checked={gst == 0 ? true : false}
                    disabled={Object.values(selectionLoading || {}).some(Boolean)}
                  // disabled={
                  //   gst  == 1
                  //     ? true
                  //     : false || tableData.some((row) => row.sku_code !== "")
                  // }
                  // disabled={
                  //   tableData.some((row) => row.sku_code !== "")
                  //     ? true
                  //     : false
                  // }
                  ></input>

                  <label htmlFor="gstExclusive"> Exclusive </label>
                </div>
              </Tooltip>
            </div>
          </fieldset>

          <fieldset className="border border-gray-900 bg-white rounded-md p-1">
            <legend className="text-gray-700 font-medium">Discount * </legend>
            <div className="flex gap-x-3">
              {/*<div className="flex items-center gap-x-1">
                 <input
                  type="radio"
                  className="form-checkbox  w-5 text-primary border-2 border-gray-400 rounded-md focus:ring-primary"
                  name="discount"
                  value="no"
                  onChange={(e) => setAmountType("no")}
                  checked={amountType === "no" ? true : false}
                  disabled={
                    projectId &&
                    (amountType === "percentage" || amountType === "price")
                  }
                ></input> 
               <label htmlFor="discountPercent">No </label> 
              </div>*/}
              <div className="flex items-center gap-x-1">
                <input
                  type="radio"
                  className="form-checkbox  w-5 text-primary border-2 border-gray-400 rounded-md focus:ring-primary"
                  name="discount"
                  value="price"
                  onChange={(e) => setAmountType("price")}
                  checked={amountType === "price" ? true : false}
                // disabled={
                //   projectId &&
                //   (amountType === "percentage" || amountType === "no")
                // }
                ></input>
                <label htmlFor="discountPrice"> Price</label>
              </div>
              <div className="flex items-center gap-x-1">
                <input
                  type="radio"
                  className="form-checkbox  w-5 text-primary border-2 border-gray-400 rounded-md focus:ring-primary"
                  name="discount"
                  value="per"
                  onChange={(e) => setAmountType("percentage")}
                  checked={amountType === "percentage" ? true : false}
                // disabled={
                //   projectId && (amountType === "no" || amountType === "price")
                // }
                ></input>
                <label htmlFor="discountPercent"> %</label>
              </div>
            </div>
          </fieldset>
        </section>
      </div>

      <main className="flex-1 create_quote w-full h-[90vh] border-b border-gray-700">
        <div className="overflow-x-auto w-full h-full">
          {(() => {
  const filteredTableData = tableData.filter((row) => row.active && row.selection == selectionId);
  let computed_total_amount = 0;
  let computed_total_quantity = 0;
  let computed_total_discount_price = 0;
  
  filteredTableData.forEach(row => {
    computed_total_amount += parseFloat(row.total || 0);
    computed_total_quantity += parseFloat(row.quantity || 0);
    computed_total_discount_price += parseFloat((row.discount_price || 0) * (row.quantity || 0));
  });

  // Assign back to the variables used in the component scope
  total_amount = computed_total_amount;
  total_quantity = computed_total_quantity;
  total_discount_price = computed_total_discount_price;

  return (
    <TableVirtuoso
      style={{ height: '70vh', width: '100%', background: 'white' }}
      data={filteredTableData}
      computeItemKey={(index, item) => item.edit_id || item.id || index}
      initialTopMostItemIndex={0}
      alignToBottom={false}
      components={VirtuosoTableComponents}
      fixedHeaderContent={() => (
        <tr className=" bg-gray-900 text-white">
                <th className="border px-1 w-16 border-slate-600 font-semibold ...">
                  Sr.No
                </th>
                <th className="border border-slate-600 font-semibold p-5 ...">
                  <BallotIcon
                    className="scale-125 hover:scale-150 hover:text-orange-500"
                    onClick={selectAll}
                  />
                </th>
                {/* <th className="border w-24 border-slate-600 font-semibold ...">
                  HSN Code
                </th> */}
                <th className="border border-slate-600 w-[9rem]  font-semibold ...">
                  Product Code{" "}
                </th>
                <th className="  min-w-[8rem] border border-slate-600 font-semibold ...">
                  Area
                </th>
                <th className="border w-20 border-slate-600 font-semibold ...">
                  Brand
                </th>
                <th className="border max-w-[8rem] pl-2 pr-2 border-slate-600 font-semibold ...">
                  Product Description <Info />
                </th>

                <th className="border w-28 border-slate-600 font-semibold ...">
                  Collection
                </th>

                <th className="border w-36 border-slate-600 font-semibold ...">
                  Product Type
                </th>

                <th className="border w-32 border-slate-600 font-semibold ...">
                  Category
                </th>
                <th className="border w-36 border-slate-600 font-semibold ...">
                  Price Segment
                  <span className="flex gap-1 items-center justify-center">
                    <ArrowDropUpIcon
                      onClick={() => sortTableAlphabetDataAsc("priceSegment")}
                      className="bg-white text-blue-600 rounded-full hover:bg-orange-600 hover:text-white hover:scale-110"
                    />
                    <ArrowDropDownIcon
                      onClick={() => sortTableAlphabetDataDesc("priceSegment")}
                      className="bg-white text-blue-600 rounded-full hover:bg-orange-600 hover:text-white hover:scale-110"
                    />
                  </span>
                </th>
                {/* <th className="border w-36 border-slate-600 font-semibold ...">
                  Spare/FG
                </th> */}
                <th className="border w-28 border-slate-600 font-semibold ...">
                  Finish
                </th>
                <th className="border min-w-[6rem] border-slate-600 font-semibold ...">
                  Product Image
                </th>
                <th className="border w-28 border-slate-600 font-semibold gap-4 ...">
                  Quantity*{" "}
                  <span className="flex gap-1 items-center justify-center">
                    <ArrowDropUpIcon
                      onClick={() => sortTableDataAsc("quantity")}
                      className="bg-white text-blue-600 rounded-full hover:bg-orange-600 hover:text-white hover:scale-110"
                    />
                    <ArrowDropDownIcon
                      onClick={() => sortTableDataDesc("quantity")}
                      className="bg-white text-blue-600 rounded-full hover:bg-orange-600 hover:text-white hover:scale-110"
                    />
                  </span>
                </th>
                <th className="border w-28 border-slate-600 font-semibold ...">
                  MRP (₹){" "}
                  <span className="flex gap-1 items-center justify-center">
                    <ArrowDropUpIcon
                      onClick={() => sortTableDataAsc("mrp")}
                      className="bg-white text-blue-600 rounded-full hover:bg-orange-600 hover:text-white hover:scale-110"
                    />
                    <ArrowDropDownIcon
                      onClick={() => sortTableDataDesc("mrp")}
                      className="bg-white text-blue-600 rounded-full hover:bg-orange-600 hover:text-white hover:scale-110"
                    />
                  </span>
                </th>
                <th className="border w-28 border-slate-600 font-semibold ...">
                  <Tooltip title="Base Price = MRP-GST" arrow>
                    <span>Base Price</span>
                  </Tooltip>
                </th>

                <th className="border w-40 border-slate-600 font-semibold ...">
                  Discount % (Per Unit)
                  <span className="flex gap-1 items-center justify-center">
                    <ArrowDropUpIcon
                      onClick={() => sortTableDataAsc("discount_per")}
                      className="bg-white ml-1 text-blue-600 rounded-full hover:bg-orange-600 hover:text-white hover:scale-110"
                    />
                    <ArrowDropDownIcon
                      onClick={() => sortTableDataDesc("discount_per")}
                      className="bg-white ml-1 text-blue-600 rounded-full hover:bg-orange-600 hover:text-white hover:scale-110"
                    />
                  </span>
                </th>
                <th className="w-[8rem] border border-slate-600 font-semibold ...">
                  <Tooltip
                    title="Discount to be given on each sku in price"
                    arrow
                  >
                    <span>
                      Discount Price (₹) (Per Unit)
                      <span className="flex gap-1 items-center justify-center">
                        <ArrowDropUpIcon
                          onClick={() => sortTableDataAsc("discount_price")}
                          className="bg-white ml-1 text-blue-600 rounded-full hover:bg-orange-600 hover:text-white hover:scale-110"
                        />
                        <ArrowDropDownIcon
                          onClick={() => sortTableDataDesc("discount_price")}
                          className="bg-white ml-1 text-blue-600 rounded-full hover:bg-orange-600 hover:text-white hover:scale-110"
                        />
                      </span>
                    </span>
                  </Tooltip>
                </th>
                <th className="border w-16 border-slate-600 font-semibold ...">
                  GST %
                </th>
                <th className="border w-32 border-slate-600 font-semibold ...">
                  Total Discount (₹)
                </th>
                <th className="border w-28 border-slate-600 font-semibold ...">
                  Total (₹)
                  <span className="flex gap-1 items-center justify-center">
                    <ArrowDropUpIcon
                      onClick={() => sortTableDataAsc("total")}
                      className="bg-white ml-1 text-blue-600 rounded-full hover:bg-orange-600 hover:text-white hover:scale-110"
                    />
                    <ArrowDropDownIcon
                      onClick={() => sortTableDataDesc("total")}
                      className="bg-white ml-1 text-blue-600 rounded-full hover:bg-orange-600 hover:text-white hover:scale-110"
                    />
                  </span>
                </th>
                <th className="border w-24 border-slate-600 font-semibold ...">
                  Stock
                </th>
                <th className="border w-32 border-slate-600 font-semibold ...">
                  Stock Indicator
                </th>
              </tr>
      )}
      fixedFooterContent={() => (
        <tr className="bg-white">
          <td colSpan={12} className="font-bold">
                Total
              </td>

              <td className="font-bold">
                {" "}
                {total_quantity ? formatNumber(total_quantity) : 0}
              </td>
              <td></td>
              <td></td>

              <td className="text-left font-semibold border border-slate-600"></td>
              <td className="font-bold">
              </td>
              <td className="text-left font-semibold border border-slate-600"></td>
              <td className="font-bold">
                {formatIndianNumber(total_discount_price)}
              </td>
              <td className="font-bold">
                {total_amount ? formatIndianNumber(total_amount) : 0}
              </td>
              <td className="font-bold">
              </td>
              <td className="font-bold">
              </td>
        </tr>
      )}
      itemContent={(index, row) => (
        <>
          
                          <td>{index + 1}</td>
                          <td className="border-b border-gray-300 p-2">
                            <input
                              type="checkbox"
                              checked={row.check === true}
                              className="form-checkbox h-5 w-5 text-blue-600 border-2 border-gray-300 rounded focus:ring-blue-500 cursor-pointer transition duration-150"
                              onChange={(e) => handleCheckboxChange(e.target.value, row.id)}
                            />
                            <br />
                            <button
                              onClick={(e) => removeRowOne(e, row.id, row.edit_id)}
                              className="text-red-600 hover:text-red-700 mt-5 hover:scale-110 border rounded-full border-red-600 p-1 hover:bg-red-50 transition duration-150"
                              title="Delete Row"
                            >
                              <div
                                dangerouslySetInnerHTML={{ __html: trash }}
                                style={{ width: "24px", height: "24px" }}
                              />
                            </button>
                            <br />
                            <button
                              onClick={() => {
                                const currentSelectionDataCount = tableData.filter(
                                  (row) => row.selection == selectionId
                                ).length;
                                if (
                                  tableData.length > 200 &&
                                  currentSelectionDataCount >= 300
                                ) {
                                  Swal.fire({
                                    icon: "error",
                                    title: "Oops...",
                                    text: "Rows Limit reached = 300",
                                  });
                                  return false;
                                }
                                inserRandomRow(row.id)
                              }}
                              className="text-gray-800 hover:text-gray-600 mt-5 hover:scale-110  rounded-full p-1 hover:bg-red-50 transition duration-150"
                              title="Insert Row"
                            >
                              <div
                                dangerouslySetInnerHTML={{ __html: inserRandom }}
                                style={{ width: "24px", height: "24px" }}
                              />
                            </button>
                          </td>
                          {/* <td> {row.hsnCode}</td> */}

                          <td>
                            <Tooltip title={row.sku_code} arrow>
                              <input
                                class=" text-xs text-center text-gray-700 border  w-[9.5rem]"
                                id="sku_code"
                                type="text"
                                onChange={(e) => handleKeyUp(e, row.id, row.edit_id)}
                                defaultValue={row.sku_code ? row.sku_code : ""}
                                style={{ borderRadius: "10px" }}
                              />
                            </Tooltip>
                          </td>

                          <td className="text-justify">
                            <label className="text-center cursor-pointer">
                              <input
                                type="radio"
                                name={"area" + [row.id]}
                                onChange={() => setArea("Shower", row.id)}
                                value="Shower"
                                checked={row.area === "Shower"}
                              />{" "}
                              SHOWER
                            </label>
                            <br />
                            <label className="text-center cursor-pointer">
                              <input
                                type="radio"
                                name={"area" + row.id}
                                onChange={() => setArea("Basin", row.id)}
                                value="Basin"
                                checked={row.area === "Basin"}
                              />{" "}
                              BASIN
                            </label>
                            <br />
                            <label className="text-center cursor-pointer">
                              <input
                                type="radio"
                                name={"area" + row.id}
                                onChange={() => setArea("EWC", row.id)}
                                value="EWC"
                                checked={row.area === "EWC"}
                              />{" "}
                              EWC
                            </label>
                            <br />
                            <label className="text-center cursor-pointer">
                              <input
                                type="radio"
                                name={"area" + row.id}
                                onChange={() => setArea("Kitchen", row.id)}
                                value="Kitchen"
                                checked={row.area === "Kitchen"}
                              />{" "}
                              KITCHEN
                            </label>
                            <br />
                            <label className="text-center cursor-pointer">
                              <input
                                type="radio"
                                name={"area" + row.id}
                                onChange={() => setArea("Faucets", row.id)}
                                value="Faucets"
                                checked={row.area === "Faucets"}
                              />{" "}
                              FAUCET
                            </label>
                          </td>
                          <td>{row.brand}</td>
                          <td
                            onMouseEnter={() => handleMouseEnter(row.id, row.sku_code)}
                            onMouseLeave={handleMouseLeave}
                            className="w-40"
                          >
                            {row.product_desc}
                          </td>

                          <td>{row.collection}</td>

                          <td> {row.Group}</td>

                          <td> {row.category}</td>
                          <td> {row.priceSegment}</td>
                          {/* <td> {row.spare_fg}</td> */}
                          <td>{row.finish}</td>

                          <td className="w-24 h-24">
                            {" "}
                            <img src={row.image} />
                          </td>
                          <td>
                            <input
                              className={`px-1 py-1 border rounded-md w-16 transition-all duration-200 outline-none ${Number(row.stock) === 0
                                ? "bg-red-300 border-red-500 text-red-900"
                                : Number(row.stock) < Number(row.quantity)
                                  ? "bg-yellow-200 border-yellow-500 text-yellow-900"
                                  : "text-gray-700 border-gray-300 focus:ring-2 focus:ring-blue-400"
                                }`}
                              type="number"
                              id=""
                              name="qty"
                              value={row.quantity}
                              onChange={(e) => changeformdataqty(e, row.id, row)}
                              size="3"

                            ></input>
                          </td>

                          <td>{formatIndianNumber(row.mrp)}</td>
                          <td>{row.unit ? formatIndianNumber(Number(row.unit)) : 0}</td>

                          <td className="">
                            <input
                              className="px-1 py-1 text-gray-700 border rounded-md w-16"
                              type="number"
                              disabled={amountType == "percentage" ? false : true}
                              onChange={(e) => {
                                let value = e.target.value;
                                const initialValue = row.discount_per;
                                if (Number(initialValue) === 0 && !isNaN(Number(value)) && value.length === 1 && value !== '0') {
                                  value = value;
                                  e.target.value = value;
                                } else if (value.length > 1 && value.startsWith('0') && !value.startsWith('0.')) {
                                  value = value.substring(1);
                                  e.target.value = value;
                                }
                                if (value.includes(".")) {
                                  const decimalIndex = value.indexOf(".");
                                  if (value.length - decimalIndex > 3) {
                                    return;
                                  } else {
                                    changeAmountType(e, row.id);
                                  }
                                } else {
                                  changeAmountType(e, row.id);
                                }
                              }}
                              value={row.discount_per}
                              placeholder="0"
                              size="3"
                            />
                          </td>
                          <td className="">
                            <input
                              className="px-1 py-1  text-gray-700 border rounded-md min-w-[5.2rem]"
                              type="number"
                              disabled={amountType === "price" ? false : true}
                              onChange={(e) => {
                                let newValue = e.target.value;
                                if (newValue.length > 1 && newValue.startsWith('0') && !newValue.startsWith('0.')) {
                                  newValue = newValue.substring(1);
                                }
                                changeAmountType({
                                  ...e,
                                  target: { ...e.target, value: newValue }
                                }, row.id);
                              }}
                              placeholder="0"
                              size="3"
                              value={row.discount_price}
                            />
                          </td>
                          <td>{gst ? row.gst : 0}</td>
                          <td>{row.total ? formatIndianNumber(row.discount_price * row.quantity) : 0}</td>
                          <td>{row.total ? formatIndianNumber(row.total) : 0}</td>
                          <td>{formatStockValue(row.stock)}</td>
                          <td>{row.stockIndicator}</td>
                        
        </>
      )}
    />
  );
})()}
        </div>
      </main>
    </>
  );
};

export default UserProjects;
